var MITS =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 43);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* Client-side form-backing object */



var WidgetUtils = {
    importStylesheet: function(libraryPath, absolutePath, media) {

        var url = (absolutePath ? libraryPath : 'styles/' + libraryPath);

        try {
            var link = document.createElement('link');
            link.setAttribute('type', 'text/css');
            link.setAttribute('rel', 'stylesheet');
            link.setAttribute('href', url);
            link.setAttribute('media', media ? media : 'all');
            var head = document.head ? document.head : document.getElementsByTagName('head')[0];
            head.appendChild(link);
        } catch (ex) {
            console.error(ex);
        }
    },

    stylesheets: [],
    requireStylesheet: function(stylesheetPackage, path, media) {
        var useAbsolute = true;
        if(path == null){
            var packageItems = stylesheetPackage.split('.');
            if(packageItems.length === 1 && packageItems[0] !== 'MITS'){ // Check for external library
                packageItems[0] = packageItems[0].toLowerCase();
                packageItems[1] = packageItems[0].toLowerCase();
                path = packageItems[0].toLowerCase() + '/' + packageItems[0].toLowerCase() + '.css';
            } else {
                packageItems.splice(0, 1);
                path = packageItems.join('/') + '.css';
            }
            useAbsolute = false;
        }

        if (WidgetUtils.stylesheets[path] == null) {
            WidgetUtils.importStylesheet(path, useAbsolute, media);
            WidgetUtils.stylesheets[path] = true;
        }
    }
};

module.exports = WidgetUtils;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This object serves to aggregate event handling functions.
 * The executeEvents() function can be registered as an event
 * handler, and it will call all the aggregated handler functions
 * that are in the events list.
 *
 * The eventScope can be set to an object needed to be applied as the
 * "this" object when the aggregated functions execute.  If it is
 * not set, the aggregated functions execute in the context of the
 * window object.
 */



var EventsHandler = function() {
    this.initialize();
};

EventsHandler.prototype = {
    events: null,
    eventScope: null,
    stopExecution: null,
    bubbleExceptions: false,

    /*
        Public Getters / Setters
    */
    setEventScope: function(scope){
        this.eventScope = scope;
    },

    getEvents: function(){
        return this.events;
    },

    /*
        Public Methods
    */
    initialize: function(){
        this.events = new Array();
    },

    addEvent: function(func){
        this.events[this.events.length] = func;
    },

    removeEvent: function(func){
        for(var i = 0; i < this.events.length; i++){
            if(this.events[i] === func){
                this.events[i] = null;
            }
        }
    },

    skipNextExecution: function() {
        this.stopExecution = true;
    },

    executeEvents: function(){
        if(this.stopExecution){
            this.stopExecution = false;
            return;
        }
        for(var i = 0; i < this.events.length; i++){
            try {
                if(this.events[i] != null){
                    if(this.eventScope != null){
                        this.events[i].apply(this.eventScope, arguments);
                    } else {
                        this.events[i].apply(window, arguments);
                    }
                }
            } catch (ex) {
                if(this.bubbleExceptions) {
                    throw ex;
                }
                console.error('Error executing event in MITS.Events.EventHandler', ex);
            }
        }
    },

    clearEvents: function() {
        for(var i = 0; i < this.events.length; i++){
            delete(this.events[i]);
            this.events[i] = null;
        }
    },

    setBubbleExceptions: function(bubble) {
        this.bubbleExceptions = bubble;
    },

    toString: function(){
        var eventsStrings = '';
        for(var i = 0; i < this.events.length; i++){
            eventsStrings += '\n\n[Index: ' + i + ']\n' + this.events[i];
        }
        return '[MITS.Events.EventsHandler]' + eventsStrings;
    }
};

module.exports = EventsHandler;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This is a static holder for the modals so they can be reference w/o loading the root MITS object
 */


var ModalManager = {};

ModalManager.getCurrentModal = function() {
    if (!ModalManager._currentModal) {
        //This is to deal w/ a circular dependency involving ModalManager and Base
        var FadeOutModal = __webpack_require__(20);
        ModalManager._currentModal = new FadeOutModal();
    }
    return ModalManager._currentModal;
};
ModalManager.getCurrentMessageModal = function() {
    if (typeof ModalManager._currentMessageModal == 'undefined') {
        ModalManager._currentMessageModal = null;
    }
    return ModalManager._currentMessageModal;
};

ModalManager.getCurrentModalWizard = function(){
    if(ModalManager._currentModalWizard == null) {
        //This is to deal w/ a circular dependency involving ModalManager and Base
        var ModalWizard = __webpack_require__(21);
        //ModalWizard.initialize() assigns itself to _currentModalWizard
        new ModalWizard();
    }
    return ModalManager._currentModalWizard;
};

module.exports = ModalManager;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
//<%@page contentType="text/javascript"%>
/**
 * @author Sam Alston
 * @fileoverview
 * The core package of the MITS JS Toolkit
 * Base for access to all of the MITS JS Toolit
 * Global utilities
 */

/**
 * MITS global namespace
 * @constructor
 */



var MITS = {
    /**
     * The version of this component
     * @final
     */
    Version: '1.0',

    /**
     *  escape dots and other problematic chars in the selector
     */
    jQueryById: function (elementId){
        return jQuery('#' + elementId.replace( /(:|\.|\[|\]|,|=|@|')/g, '\\$1' ));
    },

    /**
     Declares the package of a JS Class
     */
    setPackage: function (packagePath) {
        var packages = packagePath.split('.');
        var previousNode = this;

        for (var i = 1; i < packages.length; i++) {
            var name = packages[i].trim();
            var currentNode;
            if (previousNode[name]) {
                currentNode = previousNode[name];
            } else {
                currentNode = { };
                previousNode[name] = currentNode;
            }
            previousNode = currentNode;
        }

    },

    /**
     * Adds a javascript file to the current page
     * @param {String} libraryPath The path to the remote javascript library
     * @param {Boolean} absolutePath Specifies whether or not the passed libraryPath is an absolute path, or a path relative to the common.js
     * @param {Boolean} bruteForce Whether or not to use the standard \<script\> (true) or the not so standard ajax request
     * @param numTries
     * @member MITS
     */
    include: function (libraryPath, absolutePath, bruteForce, numTries) {

        var url = (absolutePath ? libraryPath : 'scripts/mits/' + libraryPath);

        if (bruteForce || numTries > 3) {
            document.write('<script type="text/javascript" src="' + url + '"></script>\n');
        } else {
            try {

                jQuery.ajax(url, {
                    async: false,
                    dataType:'script',
                    error: function(request, status, error) {
                        console.error('Error loading: ' + url);
                        console.error(error);
                    }
                });
            } catch (e) {
                if(e.message){
                    if (e.message.indexOf('Circular') === 0) {
                        //throw errors about circular dependencies.
                        //These should be noticed during development and testing
                        throw e;
                    }
                    else {
                        numTries = numTries != null ? numTries + 1 : 1;
                        MITS.include(libraryPath, absolutePath, bruteForce, numTries);
                    }
                } else {
                    console.error(e);
                }
            }
        }
    },

    /**
     * Ensure that the package has been loaded
     */
    _loadedFiles: [],
    _filesWaitingToLoad: [],
    require: function (packageName, path) {
        var useAbsolute = true;
        if (path == null) {
            var packageItems = packageName.split('.');
            if (packageItems.length === 1 && packageItems[0] !== 'MITS') { // Check for external library
                packageItems[0] = packageItems[0].toLowerCase();
                packageItems[1] = packageItems[0].toLowerCase();
                path = '../' + packageItems[0].toLowerCase() + '/' + packageItems[0].toLowerCase() + '.js';
            } else {
                console.warn('Blocking load of ' + packageName);
                return;
            }
            useAbsolute = false;
        }

        var found = false;
        for (var i = 0; i < MITS._loadedFiles.length; i++) {
            if (MITS._loadedFiles[i] === path) {
                found = true;
            }
        }

        if (!found) {
            MITS._filesWaitingToLoad.push(path);

            try {
                MITS._checkForCircularDependencies();
                MITS.include(path, useAbsolute);
            } finally {
                MITS._filesWaitingToLoad.pop();
            }

            MITS._loadedFiles.push(path);
        }
    },

    /**
     * Checks to see if the element at the end of the _filesWaitingToLoad
     * array is contained anywhere previously in the array. If so,
     * this means that the file ends up requiring itself before it can be
     * loaded, and an error is thrown showing the circular chain of
     * dependencies.
     */
    _checkForCircularDependencies: function() {
        var lastFile = MITS._filesWaitingToLoad[MITS._filesWaitingToLoad.length - 1];

        for (var i = 0; i < MITS._filesWaitingToLoad.length - 1; i++) {

            if (MITS._filesWaitingToLoad[i] === lastFile) {
                var circularChain = MITS._filesWaitingToLoad.slice(i);
                throw new Error('Circular dependency detected: ' + circularChain.join(' -> '));
            }
        }
    },

    /**
     * Removes the query parameter from the supplied url.
     */
    removeQueryParam: function(sourceURL, keyToRemove) {
        var rtn = sourceURL.split("?")[0],
            param,
            params_arr = [],
            queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
        if (queryString !== "") {
            params_arr = queryString.split("&");
            for (var i = params_arr.length - 1; i >= 0; i -= 1) {
                param = params_arr[i].split("=")[0];
                if (param === keyToRemove) {
                    params_arr.splice(i, 1);
                }
            }
            rtn = rtn + "?" + params_arr.join("&");
        }
        return rtn;
    }
};

MITS.Util = {

    // add this to your elements to prevent enter from submitting forms:  onkeypress="return disableEnterKey(event);"
    // use onkeypress instead of onkeydown.
    disableEnterKey: function(e){
        return !MITS.Util.wasThatTheEnterKey(e);
    },

    wasThatTheEnterKey: function(e){
        var key = MITS.Util._identifyKey(e);
        return (key === 13);
    },

    _identifyKey: function (e) {
        var key;
        if (window.event) {
            key = window.event.keyCode; //IE
        } else {
            key = e.which;
        }
        return key;
    },

    /**
     * Finds the first node with the given tagName, starting from the
     * specified node and traversing up the DOM.
     *
     * @param node The element from which to retrieve the parent node.
     * @param tagName The tag of the parent element to be searched for.
     * @return The requested parent element, or null if no such parent exists
     */
    getParent: function(node, tagName) {
         while (node.parentNode) {
            node = node.parentNode;
            if (node.tagName != null && node.tagName.toUpperCase() === tagName.toUpperCase()) {
                return node;
            }
        }

        return null;
    },

    getElementsByClass: function(searchClass, node, tag) {
        var classElements = [];
        if (node == null) {
            node = document;
        }
        if (tag == null) {
            tag = '*';
        }

        var els = node.getElementsByTagName(tag);
        var elsLen = els.length;
        var pattern = new RegExp('(^|\\s)' + searchClass + '(\\s|$)');
        for (var i = 0, j = 0; i < elsLen; i++) {
            if (pattern.test(els[i].className)) {
                classElements[j] = els[i];
                j++;
            }
        }
        return classElements;
    },

    /**
     * Creates a new version of the initially supplied function, hard-coding all subsequently supplied arguments
     * in the new function.  The intention of this is to replace the currently existing curry functionality that was
     * previously supplied to us by Prototype.
     * See http://www.westhoffswelt.de/blog/2010/10/8/currying-functions-in-javascript-a-generic-approach
     * @param fn
     * @returns {Function}
     */
    curry: function( fn /*, ... */ ) {
        var curryArgs = Array.prototype.slice.call( arguments, 1 );
        return function( /* ... */ ) {
            var newArgs    = Array.prototype.slice.call( arguments, 0 ),
                mergedArgs = curryArgs.concat( newArgs );
            return fn.apply( this, mergedArgs );
        };
    },

    /**
     * Extends the destination object, copying over, and potentially overwriting, all elements from the source object onto the destination object.
     * @param destination
     * @param source
     * @returns {*}
     * This was originally copied from Prototype.
     */
    extend: function (destination, source) {
        for (var property in source) {
            destination[property] = source[property];
        }
        return destination;
    },

    escapeHTML: function (str) {
        return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
};

/* Settings */

window.iOS = navigator.userAgent.toLowerCase().match(/(iphone|ipod|ipad)/) != null;
window.hovered = null;
window.scrolled = false;
window.scrollCurrentX = 0;
window.scrollCurrentY = 0;

/* Constants */
var DEFAULT_LOAD_TIMEOUT = 100;
var DROPDOWN_WINDOW_BUFFER = 10;
var IE_SCROLLBAR_WIDTH = 18;
window.DEFAULT_LOAD_TIMEOUT  = DEFAULT_LOAD_TIMEOUT ;
window.DROPDOWN_WINDOW_BUFFER  = DROPDOWN_WINDOW_BUFFER ;
window.IE_SCROLLBAR_WIDTH  = IE_SCROLLBAR_WIDTH ;

/****************************************************************\
 |    EVENTS                                            |
 \****************************************************************/

// Sets the current scroll location
function setScrollLocation() {
    window.scrollCurrentX = (window.pageXOffset) ? (window.pageXOffset) : (document.documentElement) ? document.documentElement.scrollLeft : document.body.scrollLeft;
    window.scrollCurrentY = (window.pageYOffset) ? (window.pageYOffset) : (document.documentElement) ? document.documentElement.scrollTop : document.body.scrollTop;
}

jQuery(window).on('scroll', setScrollLocation);
jQuery(window).on('resize', setScrollLocation);


// Sets an object's absolute position
function setRelativePosition(obj, x, y) {
    setRelativeX(obj, x);
    setRelativeY(obj, y);
}

function setRelativeX(obj, x) {
    obj.style.left = (x || 0) + 'px';
}

function setRelativeY(obj, y) {
    obj.style.top = (y || 0) + 'px';
}
window.setScrollLocation = setScrollLocation;
window.setRelativePosition = setRelativePosition;
window.setRelativeX = setRelativeX;
window.setRelativeY = setRelativeY;


/****************************************************************\
 |    APPEARANCE                                        |
 \****************************************************************/

// Unhovers the old row, and hovers the new row
function addHover(item) {
    jQuery(hovered).removeClass('hover');
    jQuery(item).addClass('hover');
    hovered = item;
}

// Tries to hide the given element id
function hide(id) {
    try {
        document.getElementById(id).style.display = 'none';
    } catch (e) {
    }
}

// Sets the title on the main frame to that of the report
function setFrameTitle() {
    if (top !== self) {
        if (document.body && document.body.className !== 'dashboard') { // make sure we're not in the dashboard
            try {
                top.document.title = document.title;
            } catch (e) {
            }
        }
    }
}
window.addHover = addHover;
window.hide = hide;
window.setFrameTitle = setFrameTitle;

jQuery(document).ready(setFrameTitle);

/****************************************************************\
 |    FORM VALIDATION TOOLS                                |
 \****************************************************************/

// Checks to see if a number is a positive integer
function isNumeric(str) {
    var NUMERIC_CHARACTERS = '0123456789';

    for (var i = 0; i < str.length; i++) {
        if (NUMERIC_CHARACTERS.indexOf(str.charAt(i)) === -1) {
            return false;
        }
    }
    return true;
}
window.isNumeric = isNumeric;


/****************************************************************\
 |    PERSISTENCE                                        |
 \****************************************************************/
function saveSetting(settingID, settingValue) {
    setCookieValue(settingID, settingValue);
}

function getSetting(settingID) {
    return getCookieValue(settingID);
}

function setCookieValue(tag, setTagValue) {
    var cookieName = 'mitspjfg';
    var cookieValue = getCookieValue('all');
    var new_cookieValue = '';
    var tag_found = false;
    var tags_exist = false;
    var separated_values = cookieValue.split('/');
    if (cookieValue !== '') {
        tags_exist = true;
        for (var loop = 0; loop < separated_values.length; loop++) {
            var tag_set = separated_values[loop];
            var tag_array = tag_set.split(':');
            var tag_ID = tag_array[0];
            var tag_setting = tag_array[1];
            if (tag_ID === tag) {
                tag_setting = setTagValue;
                tag_found = true;
            }
            if (loop > 0) {
                new_cookieValue = new_cookieValue + '/';
            }
            if (tag_ID !== tag || setTagValue !== '') {
                // Add the tag back in if it's not the one we're looking for or if it is the one we're looking for and it has a value.
                // Leave it out if we're trying to set it to empty.
                new_cookieValue = new_cookieValue + tag_ID + ':' + tag_setting;
            }
        }
    }
    if (tag_found === false) {
        if (tags_exist === true) {
            new_cookieValue = new_cookieValue + '/';
        }
        new_cookieValue = new_cookieValue + tag + ':' + setTagValue;
    }
    var expDate = new Date();
    expDate.setTime(expDate.getTime() + 1000 * 60 * 60 * 24 * 365);
    // set expiration for a year from now
    document.cookie = cookieName + '=' + encodeURIComponent(new_cookieValue) + '; expires=' + expDate.toUTCString() + ';path=/; ';
}

function getCookieValue(tag) {
    var tagValue = '';
    var cookieName = 'mitspjfg';
    if (document.cookie === '') {
        return tagValue;
    }
    var firstChar, lastChar;
    var workCookie = document.cookie;
    firstChar = workCookie.indexOf(cookieName);
    if (firstChar !== -1) { // if you found the cookie
        firstChar += cookieName.length + 1;
        // skip 'name' and '='
        lastChar = workCookie.indexOf(';', firstChar);
        // Find the end of the value string (i.e. the next ';').
        if (lastChar === -1) lastChar = workCookie.length;
        var cookieValue = decodeURIComponent(workCookie.substring(firstChar, lastChar));
        if (tag === 'all') {
            tagValue = cookieValue;
        } else {
            var separated_values = cookieValue.split('/');
            for (var loop = 0; loop < separated_values.length; loop++) {
                var tag_set = separated_values[loop];
                var tag_array = tag_set.split(':');
                var tag_ID = tag_array[0];
                var tag_setting = tag_array[1];
                if (tag_ID === tag) {
                    tagValue = tag_setting;
                }
            }
        }
    }
    return tagValue;
}
window.saveSetting = saveSetting;
window.getSetting = getSetting;
window.setCookieValue = setCookieValue;
window.getCookieValue = getCookieValue;

/****************************************************************\
 |    UTILITY                                                         |
 \****************************************************************/

// Removes leading and trailing white space
String.prototype.trim = function () {
    return this.replace(/^\s+/g, '').replace(/\s+$/g, '');
};

// Replaces all instances of a target string with a replacement string
String.prototype.replaceAll = function (from, to) {
    var str = this;
    //we split and join because the replace function only replaces
    //the first occurrence, and using replace in a loop causes an infinite
    //loop if the "from" string is contained in the "to" string
    return str.split(from).join(to);
};

// Replaces all unsafe HTML entities in a string
String.prototype.htmlDecode = function () {
    var str = this;
    str = str.replaceAll('&', '&amp;')
        .replaceAll('\'', '&#39;')
        .replaceAll('"', '&quot;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;');
    return str;
};
module.exports = MITS;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ModalManager = __webpack_require__(2);
/**
 * Contains event handler lists for success, failure, and complete events.
 * Adds checkResponseHeaders as the first success event.
 */
var EventsHandler = __webpack_require__(1);

var Base = function(){};
Base.prototype = {
    contentContainer: null,
    evaluateJavascript: true,
    ajaxStorage: null,
    asynchronous: true,
    cleanupRequestAdded: false,
    cleanupStorageAdded: false,

    submitEvents: null,
    successEvents: null,
    completeEvents: null,
    failureEvents: null,

    /*
        Public Getters / Setters
    */
    setContentContainer : function(container) {
        this.contentContainer = container;
    },
    getContentContainer : function() {
        return this.contentContainer;
    },

    setEvaluateJavascript: function(evalScript){
        this.evaluateJavascript = evalScript;
    },
    getEvaluateJavascript: function(){
        return this.evaluateJavascript;
    },

    /*
        Public Methods
    */
    addCompleteEvent: function(func){
        this.completeEvents.addEvent(func);
    },

    addFailureEvent: function(func){
        this.failureEvents.addEvent(func);
    },

    /*
        Abstract Methods
    */
    getContent: function(){
        throw 'MITS.AjaxAPI.Base.getContent is abstract and must be overridden.';
    },

    /*
        Protected Methods
    */
    initializeEventHandlers: function(){
        this.ajaxStorage = document.createElement('div');

        this.submitEvents = new EventsHandler();
        this.successEvents = new EventsHandler();
        this.completeEvents = new EventsHandler();
        this.failureEvents = new EventsHandler();
        this.failureEvents.addEvent(function(jqXHR, textStatus, errorThrown){
            if(jqXHR){
                console.error('request failed with status ' + textStatus, errorThrown);
            }
        });

        this.failureEvents.addEvent(this.handleErrorResponse.bind(this));
        this.successEvents.addEvent(this.checkResponseHeaders.bind(this));
        this.successEvents.addEvent(this.handleResponse.bind(this)); // since this only happens on success the div will only be replaced on success... we opted into this manually in ImmediateRequest
    },

    checkResponseHeaders: function(data, status, jqXHR) {
        if(jqXHR){
            if (jqXHR.getResponseHeader('MITS_AjaxResponse_CloseModal')) {
                this.completeEvents.skipNextExecution();
                try {
                    ModalManager.getCurrentModal().deactivate();
                } catch (e) {
                    console.error(e);
                }
            }
        }
    },

    getAjaxLoadDiv: function(){
        if(this.getContentContainer()){
            return this.contentContainer;
        } else {
            return this.ajaxStorage;
        }
    },

    handleResponse: function(data){
        var ajaxLoadDiv = this.getAjaxLoadDiv();
        var $resultsContainer = jQuery(ajaxLoadDiv);
        if(data) {
            // .html() executes the script tags
            $resultsContainer.html(data);
        }
        else {
            // data is undefined when the success handlers are called directly
            // this will go and re-execute the scripts already on the page, needed in order to reinitialize the modal wizard
            $resultsContainer
                .find('script')
                .each(function () {
                    eval(jQuery(this).text());
                });
        }
    },

    handleErrorResponse: function(jqXHR){
        var ajaxLoadDiv = this.getAjaxLoadDiv();
        var $resultsContainer = jQuery(ajaxLoadDiv);
        if (!(!(jqXHR) || !(jqXHR.responseText))) {
            $resultsContainer.html(jqXHR.responseText);
        }
    },

    cleanupStorage: function(){
        this.ajaxStorage.innerHTML = '';
    }

};

module.exports = Base;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Util = {

    //Used to generate a unique ID when disabling
    _overlayIdSuffix: 'disabledOverlay',
    _resizeListenerAlreadyCreated: false,
    _resizingFunctions: new Array(),
    _DEFAULT_MIN_WIDTH: 50,
    _DEFAULT_MIN_HEIGHT: 50,

    /**
     * Sets alternating CSS on table rows. Can also be called to reset the
     * CSS after dynamically adding/removing rows.
     *
     * If the table has a tbody element, all rows in the tbody will be affected.
     * If there isn't a tbody, all rows in the table will be affected.
     * "numRowsToSkip" can be specified in the options, indicating to skip the
     * first N rows in the tbody if it exists, else the table.
     *
     * Also the CSS class names can be provided as
     * "oddCss" and "evenCss" properties in the options object.
     *
     * @param table can be the ID or also the actual table element.
     * @param options an optional parameter that can be used to override defaults
     */
    /* eslint-disable complexity */
    // used only in loadColumnSetModal
    setOddEvenRowCss: function(table, options) {
        //default that can be overridden
        var oddCss = 'oddRow';
        var evenCss = 'evenRow';
        var numRowsToSkip = 0;

        if (options) {
            if (options.oddCss) {
                oddCss = options.oddCss;
            }

            if (options.evenCss) {
                evenCss = options.evenCss;
            }

            if (options.numRowsToSkip) {
                numRowsToSkip = options.numRowsToSkip;
            }
        }

        if(typeof table === 'string'){
            table = document.getElementById(table);
        }
        //skip the header rows, if any, by getting rows from the tbody
        var rowContainer = table.getElementsByTagName('tbody')[0];

        if (rowContainer == null) {
            rowContainer = table;
        }

        var rows = rowContainer.getElementsByTagName('tr');
        if (rows == null) {
            //I don't think this should ever happen.  The list
            //should be empty instead of null, but just in case...
            return;
        }

        //we ignore rows that aren't visible
        var visibleRowsCounter = 0;
        for (var i = numRowsToSkip; i < rows.length; i++) {
            var $row = jQuery(rows[i]);
            if ($row.is(':visible')) {
                if (visibleRowsCounter % 2 === 0) {
                    $row.removeClass(evenCss);
                    $row.addClass(oddCss);
                } else {
                    $row.removeClass(oddCss);
                    $row.addClass(evenCss);
                }
                visibleRowsCounter++;
            }
        }
    },
    /* eslint-enable complexity */

    /**
     * Applies a highlighting effect using a CSS class.
     *
     * @param elementId The ID of the element to be highlighted.
     */
    applyHighlightEffect: function (elementId) {
        var $element = jQuery('#' + elementId);
        $element.addClass('flash-highlight');
    },

    /**
     * Takes an element and covers it in a semi-transparent div to
     * make the element un-usable and look disabled.  Note that unlike
     * using the disabled property on form elements, this does not affect
     * what is posted to the server.  The advantage is that any element can be
     * disabled, including an entire div or page.  This function
     * needs the disabled element to have an ID, so if it doesn't have one,
     * the element will be assigned a randomly generated ID that
     * is guaranteed to be unique.
     *
     * Note: The semi-transparent div is drawn on top of an element when
     * this is called.  If the page is dynamically changed and the element's
     * position changes, the element should be re-disabled so that the
     * div will be re-drawn in the element's new position.
     *
     * Note: This function modifies the DOM, so it must be called after the
     * page has fully loaded.
     *
     * @param element can be an ID or an actual element to disable
     * @param options an optional parameter that can be used to override defaults
     */
    /* eslint-disable complexity */
    disable: function(element, options) {
        //default that can be overridden
        var disabledColor = 'white';
        var opacity = '0.8';
        var zIndex = null;
        var cursor = null;

        if (options) {
            if (options.disabledColor) {
                disabledColor = options.disabledColor;
            }

            //opacity may be 0 which is different from our default
            if (typeof options.opacity != 'undefined') {
                opacity = options.opacity;
            }

            //zIndex may be 0 which is different from our default
            if (typeof options.zIndex != 'undefined') {
                zIndex = options.zIndex;
            }

            if (options.cursor) {
                cursor = options.cursor;
            }
        }

        if(typeof element === 'string'){
            element = document.getElementById(element);
        }
        if (!element.id || element.id === '') {
            var randomId = 'randomId_' + new Date().getTime();

            while (document.getElementById(randomId)) {
                randomId = 'randomId_' + new Date().getTime();
            }

            element.id = randomId;
        }
        var overlayId = element.id + this._overlayIdSuffix;

        //get the overlay element, or create it if necissary
        var overlayElement = document.getElementById(overlayId);
        if (!overlayElement) {
            overlayElement = document.createElement('div');
            overlayElement.id = overlayId;
            overlayElement.style.backgroundColor = disabledColor;
            overlayElement.style.position = 'absolute';
            overlayElement.style.display = 'none';
            overlayElement.style.opacity = opacity;

            if (cursor) {
                overlayElement.style.cursor = cursor;
            }

            if (zIndex) {
                overlayElement.style.zIndex = zIndex;
            }

            //add the element to the parent instead of the body of the document so that:
            // 1) When the parent element moves the overlay moves with it
            // 2) When the parent element goes away the overlay is destroyed too
            var parentNode = element.parentNode;
            parentNode.appendChild(overlayElement);
        }

        //position the overlay each time in case the parent element has
        //changed position or size
        var parentDimensions;

        var $element = jQuery(element);

        if (element === document.body || element === document.documentElement) {
            //Its surprisingly difficult to get the dimensions of the entire page.
            //I didn't find anything in prototype to provide it, and this is the only
            //thing I've found that works.
            var body = document.body;
            var documentElement = document.documentElement;
            parentDimensions = {
                height: Math.max(body.scrollHeight, documentElement.scrollHeight, body.offsetHeight, documentElement.offsetHeight),
                width: Math.max(body.scrollWidth, documentElement.scrollWidth, body.offsetWidth, documentElement.offsetWidth)
            };
        } else {
            parentDimensions = {
                width: $element.outerWidth(),
                height: $element.outerHeight()
            };
        }

        //make the position of the overlay the same relative position of 
        //the element, because the overlay is on the parent just like the element 
        var parentPosition = $element.position();

        overlayElement.style.height = parentDimensions.height + 'px';
        overlayElement.style.width = parentDimensions.width + 'px';
        overlayElement.style.left = parentPosition.left + 'px';
        overlayElement.style.top = parentPosition.top + 'px';

        // give it the same margin as the overlaid element so they match up
        overlayElement.style.marginLeft = $element.css('margin-left');
        overlayElement.style.marginTop = $element.css('margin-top');

        jQuery(overlayElement).show();
    },
    /* eslint-enable complexity */

    /**
     * Enables an element previously disabled with the disable function.
     */
    enable: function(element) {
        if(typeof element === 'string'){
            element = document.getElementById(element);
        }
        var overlay = document.getElementById(element.id + this._overlayIdSuffix);
        if (overlay) {

            jQuery(overlay).remove();
            if (ie6) {
                //show the boxes we previously hid
                var selectBoxes = element.getElementsByTagName('select');
                for (var i = 0; i < selectBoxes.length; i++) {
                    jQuery(selectBoxes[i]).show();
                }
            }
        }
    },

    /**
     * Makes text in an element unselectable.  Useful for widget headings
     * and drag/drop items.
     */
    disableTextSelection: function (element) {
        if (typeof element === 'string') {
            element = document.getElementById(element);
        }
        //Note: note sure if this implementation is the best. Found this
        //code on the web.  Seems like there should be a better way
        if (typeof element.onselectstart != 'undefined') {
            //IE
            element.onselectstart = function () {
                return false;
            };
        } else if (typeof element.style.MozUserSelect != 'undefined') {
            //Firefox
            element.style.MozUserSelect = 'none';
        } else {
            //All others (Opera etc)
            element.onmousedown = function () {
                return false;
            };
        }
    },

    /** Sizes an element (usually a DIV) to fill up the width of the screen.
     * @param options an optional parameter that can be used to override defaults. Can
     *      contain any of the following:
     *      buffer: Instead of filling up the entire width of the screen, leave
     *          this many pixels between the element and the right edge.
     */

    autoSizeWidth: function(element, options) {
        this._initResizeListener();

        if(typeof element === 'string'){
            element = document.getElementById(element);
        }
        var buffer = 5;
        if (options.buffer) {
            buffer = options.buffer;
        }

        var minWidth = this._DEFAULT_MIN_WIDTH;
        if (options.minWidth) {
            minWidth = options.minWidth;
        }

        var scaling = 1;
        if (options.scaling) {
            scaling = options.scaling;
        }


        var resizeFunction = function(windowSize) {
            var leftOffset = jQuery(element).offset().left;
            var newWidth = windowSize.width - buffer - leftOffset;
            newWidth = newWidth * scaling;
            if (newWidth < minWidth) {
                newWidth = minWidth;
            }
            element.style.width = newWidth + 'px';
        }.bind(this);

        this._resizingFunctions.push(resizeFunction);

        resizeFunction(this.getViewportDimensions());
    },

    /** Sizes an element (usually a DIV) to fill up the height of the screen.
     * @param an optional parameter that can be used to override defaults. Can
     *      contain any of the following:
     *      buffer: Instead of filling up the entire height of the screen, leave
     *          this many pixels between the element and the bottom edge.
     */

    autoSizeHeight: function(element, options) {
        this._initResizeListener();        

        if (!options) {
            options = {};
        }

        if(typeof element === 'string'){
            element = document.getElementById(element);
        }
        var buffer = 15;
        if (options.buffer) {
            buffer = options.buffer;
        }

        var scaling = 1;
        if (options.scaling) {
            scaling = options.scaling;
        }

        var minHeight = this._DEFAULT_MIN_HEIGHT;
        if (options.minHeight) {
            minHeight = options.minHeight;
        }


        var resizeFunction = function(windowSize) {
            var topOffset = jQuery(element).offset().top;
            var newHeight = windowSize.height - buffer - topOffset;
            newHeight = newHeight * scaling;
            if (newHeight < minHeight) {
                newHeight = minHeight;
            }
            element.style.height = newHeight + 'px';
        }.bind(this);

        this._resizingFunctions.push(resizeFunction);

        resizeFunction(this.getViewportDimensions());
    },

    _initResizeListener: function() {
        if (this._resizeListenerAlreadyCreated) {
            return;
        }
        this._resizeListenerAlreadyCreated = true;

        jQuery(window).on('resize', function() {
            this.forceResizeWindow();
        }.bind(this));
    },
    
    forceResizeWindow: function(){
        //Only calculate the window size once because it can be slow
        var dimensions = this.getViewportDimensions();
        for (var i = 0; i < this._resizingFunctions.length; i++) {
            this._resizingFunctions[i](dimensions);
        }
    },

    getViewportDimensions: function() {
        var $window = jQuery(window);
        return {
            width: $window.width(),
            height: $window.height()
        };
    }

};

module.exports = Util;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var MITS = __webpack_require__(3);
/**
 * Allows us to "MITS.require" a DWR Service to be loaded on demand.
 */

var WebRemoting = {
    require: function(name) {
        MITS.include('dwr/interface/' + name + '.js', true);
    },

    loadService: function(name) {
        WebRemoting.require(name);
        return global[name];
    },

    errorHandler: function(message, exception, cleanupFunction) {

        var exceptionType = '';
        if (exception) {
            if (typeof exception.javaClassName == 'string') {
                exceptionType = exception.javaClassName + ' ';
            }
            else if (typeof exception.name == 'string') {
                exceptionType = exception.name + ' ';
            }
        }

        if (WebRemoting._isServerDown(exceptionType.trim())) {
            //On FireFox, we get that the server down when the user is actually
            //just navigating away from the page.  That's much more common than
            //the server actually being down, so we ignore the error.
            if (ie6 || ie7 || ie8) {
                alert('The web server is currently unreachable. Contact your system administrator.');
            }
        }
        else {
            console.error('There was an internal error: message=' + message, exception);
            alert('There was an internal error. Please try again.\n'+
                'If the problem persists, check the web server logs or contact support.\n\n' +
                'Error Details: ' + exceptionType + message);
        }

        if (typeof cleanupFunction == 'function') {
            cleanupFunction();
        }
    },

    _isServerDown: function(exceptionType) {
        if (exceptionType === 'NS_ERROR_NOT_AVAILABLE') {
            //Firefox gives this error when the server is down.
            //I'm not totally sure if it gives this error in other situations.
            return true;
        }

        if (exceptionType === 'dwr.engine.missingData') {
            //DWR gives this error in IE6 and IE7 when the server is down.
            return true;
        }

        return false;
    },


    /**
     * Most times, you will want the above errorHandler function to display the
     * error message, but after displaying the message, you need to close a modal
     * or turn off some "busy" indicator.  This function is syntactic sugar
     * that lets you specify your callback function and "cleanup" logic. 
     * It returns an "options" object, to be used with the remote method call.
     */
    createRemoteCallOptions: function(callbackFunction, cleanupFunction) {
        var options = {
            callback: callbackFunction,

            errorHandler: function(message, exception) {
                WebRemoting.errorHandler(message, exception, cleanupFunction);
            },

            warningHandler: function(message, exception) {
                WebRemoting.errorHandler(message, exception, cleanupFunction);
            }
        };

        return options;
    }
};

module.exports = WebRemoting;

// ---------------------------------------------
// Set the default error handlers.
// These can be overridden on a per-call basis.
// Java exceptions will trigger the error handler unless an
// exceptionHandler is provided on a call.
// ---------------------------------------------
dwr.engine.setErrorHandler(WebRemoting.errorHandler);
dwr.engine.setWarningHandler(WebRemoting.errorHandler);

// text handler specific to Discover
dwr.engine.setTextHtmlHandler(function() {
        //If we got a text page, that means the session timed out.
        disableUnsavedWarning();
        document.location = 'login.md';
    });
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Provides base functionality for other modals to extend.  This object
 * provides functions to show and hide the modal and functions to
 * create the modal DOM elements.
 *
 * Lifecycle
 * ---------
 * When the subclass is being created, it should call
 * _createModalElementsOnLoad to generate to modal DOM elements. The modal
 * will consist of two div elements, "model" and an inner "modalContent".
 *
 * After the modal elements are created on page load, "_createAdditionalContent"
 * will be called.  This provides a hook for subclasses to create their own
 * custom DOM elements.
 *
 * Each time the modal is being displayed, "_getContent" is called. This is
 * the hook for subclasses to put content into the "modalContainer" element.
 */


var BaseModal = function () {};

BaseModal.prototype = {
    $modal: null,
    modalId: 'mainModal',
    $modalBody: null,
    modalContentId: null,
    modalDisplayed: false,
    //A flag that indicates if we've already created the modal DOM elements
    _initialized: false,

    MODAL_CONTENT_CLASS: 'modalContent',
    MODAL_CLASS: 'mits_modal',

    className: null,

    /*
     Public Methods
     */
    activate: function () {
        this._activate();
    },

    deactivate: function () {
        this.close();
    },

    close: function () {
        this._setModalDisplayed(false);
    },

    //Useful when going from one modal straight to another
    closeModalWithoutEnablingPage: function () {
        if (this.modalDisplayed) {
            //Unless the modal is displayed, the this.modal may not be
            //initialized
            this.$modal.modal('hide');
            this.modalDisplayed = false;
        }
    },

    /**
     * This is intended for displaying error messages, which should just consist of text
     * @param content
     */
    updateModalContentText: function(content) {
        this.$modalContent.html('<div class="modal-body">' + content + '</div>');
    },

    toString: function () {
        return '[BaseModal]';
    },

    /*
     Protected Methods
     */
    _loadMarkupOnLoad: function () {
        jQuery(document).ready(this._initializeIfNot.bind(this), true);
    },

    _activate: function () {
        this._initializeIfNot();

        this._setModalDisplayed(true);
    },

    /** Shows/hides the modal and the overlay behind it. */
    _setModalDisplayed: function (display) {
        this._initializeIfNot();

        if (display && !this.modalDisplayed) {
            this.$modal.modal('show');

            this._getContent();
        } else if (!display && this.modalDisplayed) {
            this.$modal.modal('hide');
        }

        this.modalDisplayed = display;
    },

    _initializeIfNot: function() {
        if (!this._initialized) {
            this._createModalElements();
            this._initialized = true;
        }
    },

    _setSizeSmall: function() {
        var modalDialog = this.$modal.find('div.modal-dialog');
        modalDialog.addClass('modal-sm').removeClass('modal-lg');
    },

    _setSizeDefault: function() {
        var modalDialog = this.$modal.find('div.modal-dialog');
        modalDialog.removeClass('modal-sm').removeClass('modal-lg');
    },

    _setSizeLarge: function() {
        var modalDialog = this.$modal.find('div.modal-dialog');
        modalDialog.removeClass('modal-sm').addClass('modal-lg');
    },

    /**
     * Generates the necessary DOM elements for the modal and the overlay.
     * Because this modifies the DOM, it can't be called until after the page
     * has been fully loaded.
     */
    _createModalElements: function () {
        if (!this.$modal) {
            this.$modal = jQuery(
                '<div id="' + this.modalId + '" class="modal fade" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">' +
                    '<div class="modal-dialog">' +
                        '<div class="modal-content">' +
                        '</div>' +
                    '</div>' +
                '</div>');
            this.$modal.addClass(this.MODAL_CLASS);
            this.$modal.appendTo(document.body);
            this.$modalContent = this.$modal.find('div.modal-content');
            this.$modalContent.addClass(this.MODAL_CONTENT_CLASS);
            if (this.modalContentId) {
                this.$modalContent.attr('id', this.modalContentId);
            }
            this._createAdditionalContent(this.$modalContent);
        }
    },

    //Hooks for sub-classes
    _getContent: function () {
    },
    _createAdditionalContent: function () {
    }
};

module.exports = BaseModal;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Base = __webpack_require__(4);
var Events = __webpack_require__(14);
var ListenerInfo = __webpack_require__(11);
var EventsHandler = __webpack_require__(1);

/**
 * @param formID The ID of the form element.
 * @constructor
 */
var Form = function(formID) { this.initialize(formID); };

jQuery.extend(jQuery.extend(Form.prototype, Base.prototype), {
    form: null,
    iframe: null,
    excludeFromSubmitClass: 'DO_NOT_SUBMIT',
    validationEvents: null,
    validationFailureEvents: null,
    //This is a cache of the event handlers we created so
    //that we can remove them in the cleanup function
    _registeredListeners: null,

    /*
     Public Methods
     */
    initialize: function(formID){
        var listenerInfo;
        var i ;
        this.form = document.getElementById(formID);
        this.form.onsubmit = this.submit.bind(this);
        this._registeredListeners = [];

        var inputs = this.form.getElementsByTagName('input');
        for(i = 0; i < inputs.length; i++){
            if(inputs[i].type.toUpperCase() === 'SUBMIT'){
                listenerInfo = new ListenerInfo(inputs[i], 'click', jQuery.proxy(this.setSubmitButton, inputs[i]));
                this._registeredListeners.push(listenerInfo);
            }
        }

        var submitLinks = this.form.getElementsByClassName('submit');
        for(i = 0; i < submitLinks.length; i++){
            submitLinks[i].ajaxForm = this;
            listenerInfo = new ListenerInfo(submitLinks[i], 'click', jQuery.proxy(this.setSubmitLink, submitLinks[i]), true);
            this._registeredListeners.push(listenerInfo);
        }

        // For file upload, we need to post to an iframe.  This automagically creates on on any form inputs with class 'fileInput'
        if (this.form.getElementsByClassName('fileInput').length > 0) {
            var frameName = 'ajaxFormIframe_' + new Date().getTime();

            var iFrameBox = document.createElement('div');
            iFrameBox.style.width = '0px';
            iFrameBox.style.height = '0px';
            iFrameBox.innerHTML = '<iframe width="0px" height="0px" name="' + frameName + '" id="' + frameName + '"></iframe>';
            document.body.appendChild(iFrameBox);

            this.iframe = document.getElementById(frameName);
            this.form.target = frameName;

            //ie8 and lower, as well as opera 6 and lower don't do iframe.onload correctly, so use this workaround from
            //http://www.nczonline.net/blog/2009/09/15/iframes-onload-and-documentdomain/
            if (this.iframe.attachEvent) {
                this.iframe.attachEvent('onload', this.iframeComplete.bind(this));
            } else {
                this.iframe.onload = this.iframeComplete.bind(this);
            }
        }

        this.initializeEventHandlers();
        this.validationEvents = new EventsHandler();
        this.validationFailureEvents = new EventsHandler();
        this.validationEvents.setBubbleExceptions(true);

        listenerInfo = new ListenerInfo(window, 'unload', this._cleanupForm.bind(this));
        this._registeredListeners.push(listenerInfo);

        Events.registerAll(this._registeredListeners);
    },

    addSubmitEvent: function(func){
        this.submitEvents.addEvent(func);
    },

    // validation events should throw an error if something is wrong
    addValidationEvent: function(func){
        this.validationEvents.addEvent(func);
    },

    addValidationFailureEvent: function(func){
        this.validationFailureEvents.addEvent(func);
    },

    addSuccessEvent: function(func){
        this.successEvents.addEvent(func);
    },

    addCompleteEvent: function(func){
        this.completeEvents.addEvent(func);
    },

    submit: function(fromLink) {
        try {
            this.validationEvents.executeEvents();
        } catch (e) {
            this.validationFailureEvents.executeEvents();
            return;
        }

        this.submitEvents.executeEvents();

        if (this.iframe) {
            if (fromLink) {
                this.form.onsubmit = null;
                //Note: In IE when a file is submitted that does not exist, form.submit() throws an exception
                try {
                    this.form.submit();
                    return false;
                } catch (e) {
                    this.validationFailureEvents.executeEvents();
                    return;
                }
            }
            return true;
        }

        this.addCompleteEvent(function(){
            this.form = null;
        }.bind(this));

        if(!this.getContentContainer()) {
            this.addCompleteEvent(this.cleanupStorage.bind(this));
        }

        var options = {
            type: this.form.method || 'POST',
            data: this.serialize(),
            async: this.asynchronous,
            success: this.successEvents.executeEvents.bind(this.successEvents),
            complete: this.completeEvents.executeEvents.bind(this.completeEvents),
            error:  this.failureEvents.executeEvents.bind(this.failureEvents),
            url: this.form.action,
            dataType: 'html'
        };

        jQuery.ajax(options);
        return false;
    },

    // serialize everything that does not have the exclude class
    serialize: function() {
        return jQuery(this.form).not('.'+this.excludeFromSubmitClass).serialize();
    },

    excludeFromSubmit: function (elementId) {
        jQuery('#' + elementId).addClass(this.excludeFromSubmitClass);
    },

    includeInSubmit: function (elementId) {
        jQuery('#' + elementId).removeClass(this.excludeFromSubmitClass);
    },

    setSubmitButton: function(){
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = this.name;
        input.value = this.value;
        this.form.appendChild(input);
    },

    setSubmitLink: function(e){
        e.stopPropagation();

        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = this.name;
        input.value = this.name;
        this.ajaxForm.form.appendChild(input);
        this.ajaxForm.submit.bind(this.ajaxForm)(true);
    },

    iframeComplete: function() {
        var iframeDocument = this._getIframeDocument();
        if (iframeDocument && iframeDocument.body && iframeDocument.body.childNodes.length > 0) {
            this.getContentContainer().innerHTML = iframeDocument.body.innerHTML;
            jQuery('script').each(function(){
                setTimeout(function(){jQuery.globalEval(this.innerHTML);}, 10);
            });
            this.successEvents.executeEvents();
            this.completeEvents.executeEvents();
        }
    },

    toString: function() {
        return '[MITS.AjaxAPI.Form]: ' + this.form;
    },

    /*
     Overrides: MITS.AjaxAPI.Base
     */
    getContent: function(){
        this.submit();
    },

    _cleanupForm: function() {
        if(this.form) {
            Events.unregisterAll(this._registeredListeners);
            this.validationEvents.clearEvents();
            this.validationFailureEvents.clearEvents();
            this.completeEvents.clearEvents();

            this.form.onsubmit = null;
            this.form = null;
        }
    },

    /*
     Private Methods
     */
    _getIframeDocument: function() {
        var iframeDocument = null;
        if (this.iframe.contentDocument) { // For NS6
            iframeDocument = this.iframe.contentDocument;
        } else if (this.iframe.contentWindow) { // For IE5.5 and IE6
            iframeDocument = this.iframe.contentWindow.document;
        } else if (this.iframe.document) { // For IE5
            iframeDocument = this.iframe.document;
        }
        return iframeDocument;
    }
});

module.exports = Form;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Request = __webpack_require__(10);

/**
 *
 * @param url
 * @param container A DOM element or the ID of a DOM element.
 * @param options
 * @constructor
 */
var ImmediateRequest = function(url, container, options) {
    this.initialize(url, container, options);
};

jQuery.extend(jQuery.extend(ImmediateRequest.prototype, Request.prototype), {
    initialize: function(url, container, options) {
        this.requestUrl = url;

        if (typeof container === 'string') {
            this.contentContainer = document.getElementById(container);
        } else {
            this.contentContainer = container;
        }

        this.initializeEventHandlers();

        if(options){
            this.method = options.method || 'post';
            this.completeEvents.events = options.completeEvents || [];
            this.parameters = options.parameters;
        }

        this.getContent();
    }
});

module.exports = ImmediateRequest;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Base = __webpack_require__(4);

/*
 Makes an AJAX request and puts the results into a DOM element.

 Example usage:
 this.ajaxRequest = new MITS.AjaxAPI.Request();
 this.ajaxRequest.setContentContainer(containerId);
 this.ajaxRequest.setRequestUrl(url);
 this.ajaxRequest.addCompleteEvent(someFunction);

 this.ajaxRequest.getContent();
 */

/**
 *
 * @param url
 * @param container A DOM element or the ID of a DOM element.
 * @param options
 * @constructor
 */
var Request = function (url, container, options) {
    this.initialize(url, container, options);
};

jQuery.extend(jQuery.extend(Request.prototype, Base.prototype), {
    requestUrl: null,
    scope: null, //not used unless by sub-classes
    method: null, //get or post, defaults to post
    parameters: null,

    initialize: function(url, container, options) {
        this.requestUrl = url;

        if (typeof container === 'string') {
            this.contentContainer = document.getElementById(container);
        } else {
            this.contentContainer = container;
        }

        if (options) {
            this.scope = options.scope;
            this.method = options.method;
            this.evaluateJavascript = options.evaluateJavascript;
            this.parameters = options.parameters;
        }

        this.initializeEventHandlers();
    },

    /*
     Public Getters / Setters
     */
    getMethod: function () {
        return this.method;
    },
    setMethod: function (method) {
        if (method) {
            this.method = method.toLowerCase();
        }
    },

    setRequestUrl: function (url) {
        this.requestUrl = url;
    },
    getRequestUrl: function () {
        return this.requestUrl;
    },


    /*
     Overrides: MITS.AjaxAPI.Base
     */
    getContent: function () {
        this.submitEvents.executeEvents();

        try {
            var jQueryOptions = {
                type: this.getMethod() || 'POST',
                data: this.parameters,
                success: this.successEvents.executeEvents.bind(this.successEvents),
                complete: this.completeEvents.executeEvents.bind(this.completeEvents),
                error: this.failureEvents.executeEvents.bind(this.failureEvents),
                url: this.getRequestUrl(),
                dataType: 'html'
            };

        } catch (e) {
            console.error('error getting jquery options ' + e);
        }

        jQuery.ajax(jQueryOptions);
        return false;
    }
});

module.exports = Request;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This object stores all the information needed to regester and unregister
 * an event listener (aka event handler) using prototype's Event.observe
 * or Event.stopObserving.  Convenience funtions are also provided to
 * actually call observe and stopObserving using a single object or array of
 * objects.
 *
 * It is useful to store the listener information in an object because
 * unregistering a listener requires using the exact same parameters as
 * when the listener was originally registered.
 */



var ListenerInfo = function (element, eventName, observer, useCapture) {
    this.initialize(element, eventName, observer, useCapture);
};

ListenerInfo.prototype = {
    //element to attach the listener to or its ID
    element: null,
    //The name of the event to listen for, such as "click" or "hover"
    eventName: null,
    //The function to call when the event is triggered
    observer: null,
    //boolean, fire info when sinking down (true) or bubbling up (false)
    //(doesn't apply on IE, which is always up)
    useCapture: false,

    initialize: function(element, eventName, observer, useCapture) {
        this.element = element;
        this.eventName = eventName;
        this.observer = observer;

        if (typeof useCapture != 'undefined') {
            this.useCapture = useCapture;
        }
    }
};

module.exports = ListenerInfo;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Transitionable = function(){};

Transitionable.prototype = {
    enterTransition: null,
    exitTransition: null,
    getElement: null,
    setExitParticipant: null
};

module.exports = Transitionable;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var EventsHandler = __webpack_require__(1);

var Util = {
    _objectExistsType: new Array(),

    //TODO: At this time we are unable to get rid of this code, as much as I'd like to do so.  The code is currently only used in one place (Chart.js).
    //However, we're unable to tackle this until an issue pertaining to improperly saving cookies.  This code exists primarily to only render the sidebar
    //dashboards once the user actually opens the sidebar dashboard on login.  However, the benefits that we get from skipping a render are being weighed
    //against the amount of code that can be removed by getting rid of this function.
    addElementVisibleEvent: function(elementID, event, timeout){
        Util._addObjectExistsEvent('Element', elementID, event, function(){
            var $element = jQuery('#' + elementID);
            return $element.length > 0 && $element.width() > 0;
        }, timeout);
    },

    _addObjectExistsEvent: function(type, object, eventFunction, checkFunction, timeout){
        if(Util._objectExistsType[type] == null){
            Util._objectExistsType[type] = new Util.ObjectExistsType(checkFunction);
        }

        Util._objectExistsType[type].addEvent(object, eventFunction, timeout);
    }
};

// Private Class
Util.ObjectExistsType = function(checkFunction) {
    this.initialize(checkFunction);
};

Util.ObjectExistsType.prototype = {
    _intervalIds: null,
    _eventHandlers: null,
    check: null,

    initialize: function(checkFunction){
        this._intervalIds = new Array();
        this._eventHandlers = new Array();
        this.check = checkFunction;
    },

    addEvent: function(object, event, timeout){
        if(this._eventHandlers[object] != null){
            this._eventHandlers[object].addEvent(event);
            return;
        }

        if(timeout == null) {
            timeout = 250;
        }

        this._eventHandlers[object] = new EventsHandler();
        this._eventHandlers[object].addEvent(event);

        this._intervalIds[object] = window.setInterval(function(){
            if(this.check(object)){
                window.clearInterval(this._intervalIds[object]);
                this._eventHandlers[object].executeEvents();

                this._intervalIds[object] = null;
                this._eventHandlers[object] = null;
            }
        }.bind(this), timeout);
    }
};

module.exports = Util;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Events = {};
Events.EventsHandler = __webpack_require__(1);
Events.ListenerInfo = __webpack_require__(11);
Events.Transitionable = __webpack_require__(12);
Events.Util = __webpack_require__(13);

//----- 'static' functions ---
Events.register = function(listenerInfo) {
    jQuery(listenerInfo.element).on(listenerInfo.eventName, listenerInfo.observer);
};

Events.registerAll = function(listenerInfoArray) {
    for (var i = 0; i < listenerInfoArray.length; i++) {
        Events.register(listenerInfoArray[i]);
    }
};

Events.unregister = function(listenerInfo) {
    jQuery(listenerInfo.element).off( listenerInfo.eventName, listenerInfo.observer);
};

Events.unregisterAll = function(listenerInfoArray) {
    for (var i = 0; i < listenerInfoArray.length; i++) {
        Events.unregister(listenerInfoArray[i]);
    }
};

module.exports = Events;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var IPreferencesManager = function(){};

IPreferencesManager.prototype = { // Interface
    setPreference: function(name, value){},
    getPreference: function(name){},
    deletePreference: function(name){}
};

module.exports = IPreferencesManager;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @constructor
 * @param {HTMLElement|string} container The DOM object in which the accordion will be rendered. Or it can be a jQuery style selector
 * @param {Object} [options] - Optional configuration options.
 * @param {boolean} [options.showExpandCollapseIcon=false] - If <tt>true</tt>, expand/collapse icons will be displayed
 *                                                           next the the heading text
 * @param {expandCollapseCallback} [options.expandListener] - callback fired when the node is expanded
 * @param {expandCollapseCallback} [options.expandCompleteListener] - callback fired when the node finishes expanding
 * @param {expandCollapseCallback} [options.collapseListener] - callback fired when the node is collapsed
 * @param {expandCollapseCallback} [options.collapseCompleteListener] - callback fired when the node finishes collapsing
 *
 * @class
 * This accordion widget is newer and more advanced than the old
 * MITS.Widgets.AnimatedAccordian. It is essentially a wrapper around
 * Bootstrap's accordion component
 *
 * There are two ways to use this widget.  In the basic case, you provide the
 * content, and the widget handles all the events and behavior. In the advanced
 * case, content can be dynamically added and changed, and event listeners can
 * be provided to react to the expand and collapse events.
 *
 * Terminology
 * -----------
 * The heading is part of the widget the user clicks on to expand or contract
 * the accordion. It contains text and is uniquely identified by that text
 * (meaning two headings can't have the same text).
 *
 * The content is a DOM element that will be displayed below the heading. It is
 * allowed to have an ID that will not be overridden.
 *
 *
 * Example Usage
 * -------------
 * In the basic case, the JSP generates HTML for the contents of the widget.
 * (Tip: Put the contents inside a hidden div so it doesn't appear until the
 *    accordion is rendered).
 * Then JavaScript is used to create the widget and calls setHeadings,
 * providing heading titles and the IDs of the content elements.
 * The widget will create new DOM elements, and move the content elements into
 * the widget.
 */


var BootstrapAccordion = function (container, options) {
    this.initialize(container, options);
};

var NodeHandle = function($contentDiv, $expandCollapseIcon, heading) {
    this.$contentDiv = $contentDiv;
    this.$expandCollapseIcon = $expandCollapseIcon;
    this.heading = heading;
};

/**
 * @callback expandCollapseCallback
 * @param {string} heading - clicked heading
 */

NodeHandle.prototype = {
    setHeadingContent: function ($content) {
        this.$contentDiv.empty();
        this.$contentDiv.append($content);
    },

    expand: function () {
        this.$contentDiv.collapse('show');
    },

    collapse: function () {
        this.$contentDiv.collapse('hide');
    },

    addExpandCollapseListener: function(collapseExpandListener) {
        if (this.$expandCollapseIcon) {
            this.$contentDiv.on('show.bs.collapse', this._updateHeaderIconForExpand.bind(this));
            this.$contentDiv.on('hide.bs.collapse', this._updateHeaderIconForCollapse.bind(this));
        }
        this.$contentDiv.on('show.bs.collapse',
            collapseExpandListener._onExpanding.bind(collapseExpandListener, this.heading));
        this.$contentDiv.on('shown.bs.collapse',
            collapseExpandListener._onExpandComplete.bind(collapseExpandListener, this.heading));
        this.$contentDiv.on('hide.bs.collapse',
            collapseExpandListener._onCollapsing.bind(collapseExpandListener, this.heading));
        this.$contentDiv.on('hidden.bs.collapse',
            collapseExpandListener._onCollapseComplete.bind(collapseExpandListener, this.heading));
    },

    _updateHeaderIconForExpand: function(event) {
        if (event.target === event.currentTarget) {
            this.$expandCollapseIcon.removeClass('fa-caret-right');
            this.$expandCollapseIcon.addClass('fa-caret-down');
        }
    },

    _updateHeaderIconForCollapse: function(event) {
        if (event.target === event.currentTarget) {
            this.$expandCollapseIcon.addClass('fa-caret-right');
            this.$expandCollapseIcon.removeClass('fa-caret-down');
        }
    }
};

BootstrapAccordion._instanceCount = 1;
BootstrapAccordion.prototype = {
    _showExpandCollapseIcon: false,
    _headingToNodeHandle: {},

    initialize: function(container, options) {
        this._$container = jQuery(container);
        var instanceNum = BootstrapAccordion._instanceCount++;
        this._contentIdPrefix = 'content_' + instanceNum + '_';
        this._headingIdPrefix = 'heading_' + instanceNum + '_';
        this._accordionId = 'accordion_' + instanceNum;
        this._headingIdCount = 0;
        this._contentIdCount = 0;
        this._expandedHeadingsSet = {};

        if (options) {
            if (options.showExpandCollapseIcon) {
                this._showExpandCollapseIcon = true;
            }

            if (options.expandListener) {
                this._expandListener = options.expandListener;
            }

            if (options.collapseListener) {
                this._collapseListener = options.collapseListener;
            }

            if (options.expandCompleteListener) {
                this._expandCompleteListener = options.expandCompleteListener;
            }

            if (options.collapseCompleteListener) {
                this._collapseCompleteListener = options.collapseCompleteListener;
            }
        }
    },

    /**
     * Specifies the headings and the content as parallel arrays.
     * This function can be called multiple times to dynamically
     * clear out the headings (and content) and insert new ones.
     *
     * @param headingArray An array of Strings that will be heading titles.
     *        This is required.
     * @param contentArray An array of DOM elements or element IDs. This
     *        is optional, since content can be provided later.
     *
     * Note: This modifies the DOM, and can't be called until the page
     * is fully loaded.
     */
    setHeadings: function (headingArray, contentArray) {
        this._headingToNodeHandle = {};
        this.$root = jQuery('<div class="panel-group" id="' + this._accordionId + '" role="tablist" aria-multiselectable="true"></div>');

        for (var i = 0; i < headingArray.length; i++) {
            var heading = headingArray[i];
            var handle = this._addHeadingToContainer(heading, contentArray[i]);
            handle.addExpandCollapseListener(this);
            this._headingToNodeHandle[heading] = handle;
        }

        var $wrapper = jQuery('<div class="bootstrap-accordion">');
        this.$root.appendTo($wrapper);
        $wrapper.appendTo(this._$container);
    },

    /**
     * Sets the content for a specific heading. Note that setHeadings
     * must be called first.
     *
     * @param heading - a heading string that was previously passed
     *        to the setHeadings function.
     * @param content - a DOM element or element ID
     */
    setHeadingContent: function (heading, content) {
        var handle = this._headingToNodeHandle[heading];
        var $bodyDiv = this._create$ContentCell(content);
        handle.setHeadingContent($bodyDiv);
    },

    /**
     * Gets and array containing the text of the currently expanded headings.
     * They are in order from oldest to most recently expanded.
     */
    getExpandedHeadings: function () {
        return Object.keys(this._expandedHeadingsSet);
    },

    /**
     * @param heading - The text of the heading to expand.
     */
    expand: function (heading) {
        var handle = this._headingToNodeHandle[heading];
        handle.expand();
    },

    /**
     * @param heading - The text of the heading to collapse.
     */
    collapse: function (heading) {
        var handle = this._headingToNodeHandle[heading];
        handle.collapse();
    },

    collapseAll: function() {
        var expandedHeadings = this.getExpandedHeadings();

        for(var i=0;i<expandedHeadings.length;i++){
            var heading = expandedHeadings[i];
            this.collapse(heading);
        }
    },

    _addHeadingToContainer:function(heading, content) {
        var containerId = this._accordionId;
        var id = heading.replace(new RegExp('[^A-Za-z0-9]', 'g'), '_');
        var headingId = this._headingIdPrefix + id + this._headingIdCount++;
        var contentId = this._contentIdPrefix + id + this._contentIdCount++;

        var handles = this._create$HeadingDiv(headingId, containerId, contentId, heading);
        var $headingDiv = handles.$headingDiv;
        var $expandCollapsIcon = handles.$expandCollapsIcon;
        var $bodyDiv = this._create$ContentCell(content);

        var $contentDiv = jQuery('<div id="' + contentId + '" class="panel-collapse collapse" role="tabpanel" aria-labelledby="' + headingId + '"></div>');
        $contentDiv.append($bodyDiv);

        var $entryDiv = jQuery('<div class="panel panel-default"></div>');
        $entryDiv.append($headingDiv);
        $entryDiv.append($contentDiv);
        this.$root.append($entryDiv);
        return new NodeHandle($contentDiv, $expandCollapsIcon, heading);
    },

    _create$HeadingDiv: function(headingId, containerId, contentId, heading) {
        var $heading = jQuery('<div class="panel-heading" role="tab" id="' + headingId + '"></div>');
        var $h4 = jQuery('<h4 class="panel-title"></h4>');
        $heading.append($h4);
        var $anchor = jQuery('<a role="button" class="collapsed" aria-expanded="false" data-toggle="collapse" data-parent="#' + containerId + '" href="#' + contentId + '" aria-expanded="true" aria-controls="collapseOne"></a>');
        $h4.append($anchor);
        var $expandCollapsIcon = null;
        if (this._showExpandCollapseIcon) {
            $expandCollapsIcon = jQuery('<span class="fa fa-fw fa-caret-right" aria-hidden="true"></span>');
            $anchor.append($expandCollapsIcon);
            $anchor.append('<span>' + heading + '</span>');
        } else {
            $anchor.text(heading);
        }
        return { $headingDiv: $heading, $expandCollapsIcon: $expandCollapsIcon };
    },

    _onExpanding: function(heading, e) {
        this._expandedHeadingsSet[heading] = true;
        if(this._expandListener) {
            this._expandListener(heading, e);
        }
    },

    _onExpandComplete: function(heading, e) {
        if(this._expandCompleteListener) {
            this._expandCompleteListener(heading, e);
        }
    },

    _onCollapsing: function(heading, e) {
        delete this._expandedHeadingsSet[heading];
        if(this._collapseListener) {
            this._collapseListener(heading, e);
        }
    },

    _onCollapseComplete: function(heading, e) {
        if(this._collapseCompleteListener) {
            this._collapseCompleteListener(heading, e);
        }
    },

    _create$ContentCell: function(content) {
        var $bodyDiv = jQuery('<div class="panel-body mits-panel-no-body-padding"></div>');
        if (typeof content === 'string') {
            $bodyDiv.text(content);
        } else {
            $bodyDiv.append(content);
        }
        return $bodyDiv;
    }
};


module.exports = BootstrapAccordion;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var CheckableRowsTable = __webpack_require__(18);
/**
 * This object is similar to the CheckableRowsTable, but instead of working
 * with tables that have an arbitrary number of columns, this only allows
 * a checkbox and a text description.
 *
 * Another difference is that the CheckableRowsTable can be applied
 * to HTML that is already in the page, but this widget manages its own
 * DOM objects and all items must be added to the list programmatically using
 * JavaScript.
 */
var CheckableItemsList = function(container, options) {
    this.initialize(container, options);
};
CheckableItemsList._instanceCount = 1;
CheckableItemsList.prototype = {

    //--- Constants ---
    _idPrefix: 'checkableItemId_',

    _tableBody: null,
    _externalIdToInternalIdMap: null,
    _clickListener: null,
    _numItemsAdded: 0,
    _selectedIds: null, //Consider this a HashSet of the user-provided IDs for all the checked items
    _useRadioButtons: false,
    _radioGroupName: null,
    _formFieldName: null,

    /**
	 * @param container - a div DOM element or the ID of one. This is expected
	 *      to be an empty div. If it contains any child nodes, they
	 *      will be removed from the DOM.
	 * @param options - contains the following optional settings:
	 *  	clickListener: a function that will be called when
	 *	 		an item is checked or unchecked.  It will be passed the
	 *          item id, the item description, and a boolean indicating if
	 *          the item is now checked.
	 * 		allowRangeSelection: A boolean that if set to true, will
	 * 			allow the user to check (but not uncheck) a range of
	 * 			rows by clicking on one and releasing on another.
	 * 		clickedCss: the CSS added to a table row if (and only if) the box is checked
     *      useRadioButtons: Switches from check-boxes to radio buttons, and disables range selection
     *      formFieldName: The name of the form field, used if you need to submit the checked items.  The values of the
     *          form fields will be IDs of the items.  If using radio buttons, the name of the form field also
     *          groups radio-buttons into a set that are mutually exclusive to select.
	 */
	initialize: function(container, options) {
        //Give this instance a unique prefix it can use for its items so they don't clash
        //with IDs for items from other CheckableItemsList instances on the same page.
        this._idPrefix = this._idPrefix + CheckableItemsList._instanceCount++ + '_';

        this._selectedIds = {};
        this._externalIdToInternalIdMap = {};

        if (!options) {
            options = {};
        }

        //radioGroupName is deprecated in favor of formFieldName, but MITS Report may still be using it for the calculated columns wizard
        if (!options.formFieldName && options.radioGroupName) {
            options.formFieldName = options.radioGroupName;
        }

        if (options.formFieldName) {
            this._formFieldName = options.formFieldName;
        }

        if (options.useRadioButtons) {
            this._useRadioButtons=true;
            options.allowRangeSelection = false;

            if (!options.formFieldName) {
                this._formFieldName = 'checkableItemsTableRadioGroup_' + CheckableItemsList._instanceCount;
            }
        }


        //replace the provided click-listener with our own internal one
        //that will delegate
        this._clickListener = options.clickListener;
        options.clickListener = this._internalClickListener.bind(this);

        var $container;
        if (typeof container === 'string') {
            $container = jQuery('#' + container);
        } else {
            $container = jQuery(container);
        }
        $container.empty();

        var table = document.createElement('table');
        table.classList.add("table", "table-condensed");
        $container.append(table);

        //IE won't display our table rows if we add them directly
        //to the table. So we have to create this head/foot/body junk
        //and add the rows to the body.
        table.appendChild(document.createElement('thead'));
        table.appendChild(document.createElement('tfoot'));
        this._tableBody = document.createElement('tbody');
        table.appendChild(this._tableBody);

        this._checkableRowsTable = new CheckableRowsTable(table, options);
    },

    addItem: function(id, description, initiallyChecked) {

        //Map from the user-provided ID to another unique IDs in case the
        //provided ID has characters that are invalid for HTML ID values.
        var internalId = this._idPrefix + this._numItemsAdded++;
        this._externalIdToInternalIdMap[id] = internalId;


        var row = document.createElement('tr');
        var cell = document.createElement('td');
        var checkbox = document.createElement('input');
        if (this._useRadioButtons) {
            checkbox.type = 'radio';
            checkbox.name = this._formFieldName;
        }
        else {
            checkbox.type = 'checkbox';
            if (this._formFieldName) {
                checkbox.name = this._formFieldName;
            }
        }

        checkbox.id = internalId;
        checkbox.value = id;
        //We set the defaultChecked instead of checked
        //because IE resets the checked property to the
        //default when the element is added to the DOM
        if (initiallyChecked) {
            checkbox.defaultChecked = true;
            this._selectedIds[id] = id;
        }

        cell.style.width = '1%';
        cell.appendChild(checkbox);
        row.appendChild(cell);

        cell = document.createElement('td');
		cell.style.verticalAlign = 'middle';

        var text = document.createTextNode(description);
        cell.appendChild(text);

        row.appendChild(cell);

        this._tableBody.appendChild(row);

        if (this._numItemsAdded % 2 === 1) {
            row.className = 'oddRow';
        }
        else {
            row.className = 'evenRow';
        }

        this._checkableRowsTable.prepareRow(row);
    },

    addAdditionalItemsNotice: function (msg) {
        var additionalItems = jQuery('<tr><td colspan="2" style="font-style: italic; height: 3em; text-align: center; vertical-align: middle; color: red; font-size: larger;">' + msg + '</td></tr>');
        additionalItems.appendTo(this._tableBody);
    },

    uncheckAllItems: function() {
        this._checkableRowsTable.uncheckAllRows();
        this._selectedIds = {};
    },

    checkItem: function(id) {
        this.setChecked(id, true);
    },

    uncheckItem: function(id) {
        this.setChecked(id, false);
    },

    //Silently handles invalid IDs
    setChecked: function(id, checked) {
        if (checked) {
            this._selectedIds[id] = id;
        }
        else {
            delete this._selectedIds[id];
        }
        var internalId = this._externalIdToInternalIdMap[id];
        var checkbox = document.getElementById(internalId);
        if (checkbox) {
            checkbox.checked = checked;
            this._checkableRowsTable.updateClickedCss(checkbox);
        }
    },

    isChecked: function(id) {
        var internalId = this._externalIdToInternalIdMap[id];
        var checkbox = document.getElementById(internalId);
        return checkbox.checked;
    },

    getCheckedIds: function() {
        return Object.keys(this._selectedIds); //returns an array of Strings
    },

    getInternalId: function(id) {
        return this._externalIdToInternalIdMap[id];
    },


    _internalClickListener: function(checkbox) {
        var row = checkbox.parentNode.parentNode;
        var cell2 = row.lastChild;
        var id = checkbox.value;
        var label = cell2.firstChild.data;
        var isChecked = checkbox.checked;

        if (isChecked) {
            this._selectedIds[id] = id;
        }
        else {
            delete this._selectedIds[id];
        }

        if (this._clickListener) {
            this._clickListener(id, label, isChecked);
        }
    }
};

module.exports = CheckableItemsList;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This object takes a table where rows can be selected by clicking a check box.
 * It makes it possible to click anywhere on the row to check/uncheck the box.
 * Rows where the checkbox is checked are given CSS allowing them to
 * visually stand out.
 * Each table row is expected to have a check box, and it should be the first
 * input element in the row.
 * If the table has a tbody element, all rows in the tbody will be affected.
 * If there isn't a tbody, all rows in the table will be affected.
 * "numRowsToSkip" can be specified in the options, indicating to skip the
 * first N rows in the tbody if it exists, else the table.
 *
 *
 * When the CheckableRowsTable is created, it walks the table and prepares
 * the rows, adding css and event listeners.  If rows are dynamically added to
 * the table later, each new row should be passed to the prepareRow() function.
 *
 * If the checkbox is dynamically checked or uncheck using javascript, an
 * event won't be triggered to change the CSS, so the updateClickedCss()
 * function should be called.
 */



var CheckableRowsTable = function (table, options) {
    this.initialize(table, options);
};

CheckableRowsTable._instanceCount = 1;
CheckableRowsTable.prototype = {

    _rowIdPrefix: 'clickableRowId_',
    _clickedCss: 'hover',
    _clickListener: null,
    _allowRangeSelection: false,
    _lastMouseDownRow: null,
    _numRowsInTable: 0,
    _rowContainer: null,

    /**
     * @param table - a table DOM element or the ID of one
     * @param options - contains the following optional settings:
     *    clickListener: a function that will be called when
     *            a checkbox is checked or unchecked.  It will be passed
     *            a single argument, the checkbox DOM element.
     *        allowRangeSelection: A boolean that if set to true, will
     *            allow the user to check (but not uncheck) a range of
     *            rows by clicking on one and releasing on another.
     *            To support this, table rows will be assigned ID values, meaning
     *            you cannot use your own ID values on the rows.
     *            Also, any rows dynamically added to the table can only
     *            be added to the end of the table, and prepareRow must be called
     *            in the order they are added.
     *        clickedCss: the CSS added to a table row if (and only if) the box is checked
     *        numRowsToSkip: Specifies the number of rows that should be treated as
     *            header rows.
     */
    /* eslint-disable complexity */
    initialize: function (table, options) {
        //Give this instance a unique prefix it can use for its rows
        this._rowIdPrefix = this._rowIdPrefix + CheckableRowsTable._instanceCount++ + '_';

        if(typeof table === 'string'){
            table = document.getElementById(table);
        }

        var numRowsToSkip = 0;
        if (options) {
            //allow the user to override the 'hightlight row' CSS, if desired
            if (options.clickedCss) {
                this._clickedCss = options.clickedCss;
            }

            if (options.clickListener) {
                this._clickListener = options.clickListener;
            }

            if (options.allowRangeSelection) {
                this._allowRangeSelection = options.allowRangeSelection;
            }

            if (options.numRowsToSkip) {
                numRowsToSkip = options.numRowsToSkip;
            }
        }

        if (table != null) {
            //skip the header rows, if any, by getting rows from the tbody
            this._rowContainer = table.getElementsByTagName('tbody')[0];

            if (this._rowContainer == null) {
                this._rowContainer = table;
            }

            var rows = this._rowContainer.getElementsByTagName('tr');
            if (rows != null) {
                for (var i = numRowsToSkip; i < rows.length; i++) {
                    this.prepareRow(rows[i]);
                }
            }

            //We observe mouse down events for the whole page so that
            //nothing will happen if the user mousedown's outside the
            //table and the releases on a row.
            jQuery(document).on('mousedown', function (event) {
                var targetElement = event.target;
                //If the target is in the table, find the row
                //that was clicked
                if (jQuery.contains(table, targetElement)) {
                    this._lastMouseDownRow = MITS.Util.getParent(targetElement, 'tr');
                } else {
                    this._lastMouseDownRow = null;
                }
            }.bind(this));
        }
    },
    /* eslint-enable complexity */

    /**
     * Note: don't call this function more than once for the same
     * row. It would add multiple listeners to the row, which would
     * step on each other.
     */
    prepareRow: function (row) {
        var $row = jQuery(row);
        row.style.cursor = 'default';

        if (this._allowRangeSelection) {
            this._numRowsInTable++;
            row.id = this._rowIdPrefix + this._numRowsInTable;
        }

        var checkbox = this._getCheckboxFromRow(row);

        if (checkbox == null) {
            $row.removeClass(this._clickedCss);
            return;
        }

        //Toggle the checkbox when the row has a mouse up.
        //(We don't use click because we are stopping those events on
        // the checkbox.  See below.)
        $row.on('mouseup', function () {
            return this._handleRowClick(row);
        }.bind(this));

        //We want double clicks to function the same as a single click.
        //When a double click is triggered, there are also two normal
        //click events. On the double click event, we'll just toggle
        //a third time to get back to the single click state, which is a lot easier
        //than adding complex logic to make sure we only toggle once.
        $row.on('dblclick', function () {
            return this._handleRowClick(row);
        }.bind(this));


        // Because the toggle logic is happening in the row's event listener,
        // we need to suppress the browser's normal behavior of toggling the
        // checkbox when the checkbox is clicked.
        jQuery(checkbox).on('click', function (event) {
            //Note that for radio-buttons on FireFox,
            //the browser is doing its UI update before
            //this method is called, which means we can't stop it.
            //For selecting a radio button, it's ok for the browser
            //to select it again.  For unselecting, we don't
            //allow ourselves to unselect in _toggleRowSelection() below,
            //and let the browser re-select the already selected radio button.
            //This means we can't unselect a selected radio button, but that's
            //normal behavior. Bugzid: 34644
            event.stopPropagation();

            return false;
        }.bind(this));

        this.updateClickedCss(row);
    },

    /**
     * Checks the state of the checkbox, and updates the CSS to highlight
     * or un-highlight the row.  Either the row or the checkbox can
     * be passed in.
     */
    updateClickedCss: function (rowOrCheckbox) {
        var checkbox, row;

        if (typeof rowOrCheckbox.checked == 'undefined') {
            row = rowOrCheckbox;
            checkbox = this._getCheckboxFromRow(row);
        } else {
            checkbox = rowOrCheckbox;
            row = MITS.Util.getParent(checkbox, 'tr');
        }

        if (checkbox.checked) {
            jQuery(row).addClass(this._clickedCss);
        } else {
            jQuery(row).removeClass(this._clickedCss);
        }
    },

    uncheckAllRows: function () {
        var rows = this._rowContainer.getElementsByTagName('tr');

        for (var i = 0; i < rows.length; i++) {
            var checkbox = this._getCheckboxFromRow(rows[i]);
            if (checkbox && checkbox.checked) {
                checkbox.checked = !checkbox.checked;
                this.updateClickedCss(checkbox);
                if (this._clickListener != null) {
                    this._clickListener(checkbox);
                }
            }
        }
    },

    checkAllRows: function () {
        var rows = this._rowContainer.getElementsByTagName('tr');

        for (var i = 0; i < rows.length; i++) {
            var checkbox = this._getCheckboxFromRow(rows[i]);
            if (checkbox && !checkbox.checked) {
                if (checkbox.type !== 'radio') {
                    this._toggleRowSelection(rows[i]);
                }
            }
        }
    },

    _getCheckboxFromRow: function (row) {
        return row.getElementsByTagName('input')[0];
    },

    /**
     * Determines if a single row or range of rows was clicked on.
     */
    _handleRowClick: function (row) {
        if (this._lastMouseDownRow === row) {
            this._toggleRowSelection(row);
        }
        else if (this._allowRangeSelection && this._lastMouseDownRow != null) {
            var row1Index = this._lastMouseDownRow.id.substring(this._rowIdPrefix.length);
            var row2Index = row.id.substring(this._rowIdPrefix.length);

            //Convert the Strings to numbers so we get accurate comparison results
            row1Index = parseInt(row1Index);
            row2Index = parseInt(row2Index);


            if (row1Index < row2Index) {
                var firstIndex = row1Index;
                var lastIndex = row2Index;
            }
            else {
                var firstIndex = row2Index;
                var lastIndex = row1Index;
            }

            for (var i = firstIndex; i <= lastIndex; i++) {
                var row = document.getElementById(this._rowIdPrefix + i);
                var checkbox = this._getCheckboxFromRow(row);
                if (!checkbox.checked) {
                    this._toggleRowSelection(row);
                }
            }

            this._unselectTheSelectedText();
        }
    },

    _toggleRowSelection: function (row) {
        var checkbox = this._getCheckboxFromRow(row);
        if (checkbox.type === 'radio') {
            if (checkbox.checked) {
                //Don't allow unselecting a radio button
                //because we are unable to stop the normal
                //browser behavior up a above on the click event,
                //which selects it again. See bugzid: 34644
                return;
            }
            else {
                //We're about to select a radio button.
                //Clear the currently selected radio button, if any
                this.uncheckAllRows();
            }
        }

        //Toggle the checkbox and the CSS
        checkbox.checked = !checkbox.checked;
        this.updateClickedCss(checkbox);
        if (this._clickListener != null) {
            this._clickListener(checkbox);
        }
    },

    _unselectTheSelectedText: function () {
        if (document.selection) {
            document.selection.empty();
        }
        else if (window.getSelection) {
            window.getSelection().removeAllRanges();
        }
    }
};

module.exports = CheckableRowsTable;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Util = __webpack_require__(5);

/**
 * Displays a message directly over a specific page element.
 * Can optionally gray out the element while showing the message.  Graying
 * out can be disorienting if the message quickly goes away,
 * so it should probably only be used when the message is guaranteed to
 * appear for at least a few seconds.
 *
 */
var ElementSpecificMessage = function (elementToDisplayOver, message, options) {
    this.initialize(elementToDisplayOver, message, options);
};

ElementSpecificMessage.prototype = {
    _$messageDiv: null,
    _$elementToDisplayOver: null,
    _shouldGreyOut: false,
    _message: null,
    _messageCssClass: null,

    /**
     * @param elementToDisplayOver Can be an element ID or an actual DOM element
     */
    initialize: function (elementToDisplayOver, message, options) {

        if(typeof elementToDisplayOver === 'string'){
            elementToDisplayOver = document.getElementById(elementToDisplayOver);
        }

        if (options) {
            if (options.shouldGrayOut) {
                this._shouldGreyOut = options.shouldGrayOut;
            }

            if (options.messageCssClass) {
                this._messageCssClass = options.messageCssClass;
            }
        }

        this._message = message;
        this._$elementToDisplayOver = jQuery(elementToDisplayOver);
    },

    //We don't init until the first time we need to show() because we
    //have to add elements to the DOM, and in IE, you can't modify
    //the DOM until the page is loaded.  We can't be sure the page
    //has been loaded when the constructor is called, but presumably
    //it will be loaded when show() is called.
    _init: function () {
        this._$messageDiv = jQuery("<div class='elementSpecificMessage'><div class='center-block'><span class='" + this._messageCssClass + "'>" + this._message + '</span></div></div>');
        this._$centerBlock = this._$messageDiv.find(">:first-child");
        this._$messageSpan = this._$messageDiv.find("span." + this._messageCssClass);

        this._$messageDiv.css({
            display: 'none',
            height: this._$elementToDisplayOver.height() + 'px'
        });
        this._$messageDiv.appendTo(this._$elementToDisplayOver);
    },

    show: function () {
        //Do the disabling first so that the message div will
        //appear on top of the gray-out div
        if (this._shouldGreyOut) {
            Util.disable(this._$elementToDisplayOver[0]);
        }

        if (this._$messageDiv == null) {
            this._init();
        }

        this._$messageDiv.show();

        this._$centerBlock.css({
            height: this._$messageSpan.outerHeight(),
            width: this._$messageSpan.outerWidth(),
            paddingTop: (this._$elementToDisplayOver.height() - this._$messageSpan.outerHeight()) / 2
        });
    },

    hide: function () {
        this._$messageDiv.hide();
        Util.enable(this._$elementToDisplayOver[0]);
    }
};

module.exports = ElementSpecificMessage;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BaseModal = __webpack_require__(7);
var ImmediateRequest = __webpack_require__(9);
var WidgetUtils = __webpack_require__(0);
var EventsHandler = __webpack_require__(1);
WidgetUtils.requireStylesheet('MITS.Widgets.FadeOutModal');

var FadeOutModal = function() {
    this.initialize();
};

/**
 * This improves upon the base modal by modifying the activate function to
 * take a URL which will be displayed in the modal.  Also support is added
 * for firing events when the modal is closed, and to have the modal indicate
 * when it is busy loading content.
 *
 * Ironically, the FadeOutModal doesn't contain any code related to fading in or out.
 * That functionality is provided for us in the BaseModal that we extend.
 */
jQuery.extend(jQuery.extend(FadeOutModal.prototype, BaseModal.prototype), {
    method: 'post',
    closeEvents: null,
    loading: false,

    oldLocation: null,
    url: null,
    formData: null, //Serialized string
    
    /*
        Public Getters / Setters
    */
    getContentContainer: function() {
        return this.$modalContent.get(0);
    },

    getUrl: function() {
        return this.url;
    },

    setMethod: function(method) {
        this.method = method;
    },

    setFormData: function(formData) {
        this.formData = formData;
    },

    /*
        Public Methods
    */
    initialize: function() {
        this.closeEvents = new EventsHandler();

        this._loadMarkupOnLoad();
    },

    activate: function(url, className, retries) {
        try {
            if (url) {
                this.url = url;
            }

            //calls the super._activate which will call our _getContent function
            this._activate();
        } catch (e) {
            if(!retries || retries <= 3) {
                setTimeout(MITS.Util.curry(this.activate.bind(this), url, className, retries ? retries + 1 : 1), 500);
            }
        }
    },

    // Note this calls the closeEvents, but the close() method does not.  I would like to get rid of this distinction but it
    // would require touching Report which we can't do right now.  Instead I've changed uses of .close() to .deactivate()
    // in Discover, and cleared out the closeEvents before calling it in the one place it mattered.
    deactivate: function() {
        if(this.modalDisplayed) {
            if(this.closeEvents.getEvents().length > 0){
                this.closeEvents.executeEvents();
                this.closeEvents = new EventsHandler();

                if(!this.loading) {
                    this.close();
                }
                this.loading = false;
            } else {
                this.close();
            }
        }
    },

    /**
     * Sometimes a modal wants to refresh the page it is displayed on top of, such
     * as when you close the generic ajax-exception modal. In most cases, it's OK
     * to simply reload the current URL.  But sometimes, the parent page may want
     * to override this function to do special reload logic.  For example, if the
     * parent page is actually a dummy page whose only purpose is to launch a modal,
     * then a refresh should probably return the user to the previous non-dummy page.
     * Or if the URL has a URL parameter that was supposed to trigger a one-time action,
     * such as highlighting a newly created item.  Then refresh logic would reload the URL
     * without that one-time URL parameter.
     */
    reloadParentPage: function() {
        var url = document.location.href;
        if(url.lastIndexOf('#') === url.length - 1){
            url = url.substring(0, url.length - 1);
        }
        document.location = url;
    },

    updateContent: function(url) {
        if (url) {
            this.url = url;
        }
        this._getContent();
    },
    
    /**
     * just like updateContent but without clearing the contents or putting up a loading message
     */
    updateContentFast: function(url) {
        if (url) {
            this.url = url;
        }
        new ImmediateRequest(this.url, this.getContentContainer(), {
            method: this.method,
            completeEvents: [this.hideLoading.bind(this)]
        });
    },

    showLoading: function() {
        this.$modalContent.removeClass('loaded');
        this.$modalContent.addClass('loading');
    },

    hideLoading: function() {
        this.$modalContent.removeClass('loading');
        this.$modalContent.addClass('loaded');
    },

    addCloseEvent: function(func) {
        this.closeEvents.addEvent(func);
    },

    toString: function(){
        return '[FadeOutModal]';
    },

    /**
     *  reset to original size
     */
    resetModal: function(){
        this._setSizeDefault();
    },

    /**
     * Call this to set the modal to a width of 300px. It'll reset itself when deactivated but you can use resetModal
     * explicitly to reset if the different pages of your wizard are different sizes.
     * <b>Important</b> ensure that you close any resized modals using <code>MITS.getCurrentModal().deactivate();</code>
     * rather than <code>MITS.getCurrentModal().close();</code> because close does not call the closeEvents, but deactivate does.
     */
    resizeModalToSmall: function() {
        this._setSizeSmall();
        this._scheduleResetSizeOnClose();
    },

    /**
     * Call this to set the modal to a width of 600px. This is the default width, so it won't reset itself when deactivated.
     */
    resizeModalToDefault: function() {
        this._setSizeDefault();
    },

    /**
     * Call this to set the modal to a width of 900px. It'll reset itself when deactivated but you can use resetModal
     * explicitly to reset if the different pages of your wizard are different sizes.
     * <b>Important</b> ensure that you close any resized modals using <code>MITS.getCurrentModal().deactivate();</code>
     * rather than <code>MITS.getCurrentModal().close();</code> because close does not call the closeEvents, but deactivate does.
     */
    resizeModalToLarge: function() {
        this._setSizeLarge();
        this._scheduleResetSizeOnClose();
    },

    _scheduleResetSizeOnClose: function() {
        var resetOnClose = function(){
            this.closeEvents.removeEvent(resetOnClose);
            this.resetModal();
        };
        
        this.addCloseEvent(resetOnClose.bind(this));
    },
    
    /*
        Private Methods
     */
    
    _getContent: function() {
        this.showLoading();

        this.$modalContent.html('<div class="modal-body"></div>');

        var serializedForm = this.formData;
        //Assume the form data is only valid for a single time the modal loads and don't try
        //to resend the same data
        this.formData = null;

        new ImmediateRequest(this.url, this.getContentContainer(), {
            method: this.method,
            parameters: serializedForm,
            completeEvents: [this.hideLoading.bind(this), this._setTouchstartListener]
        });
    },
    
    _setTouchstartListener: function(){
        var $modalMainContent = jQuery('.modalMainContent');
        if ($modalMainContent.length) {
            $modalMainContent.on('touchstart', function () {
            });
        }
    }
    
});

module.exports = FadeOutModal;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ModalManager = __webpack_require__(2);

var ModalWizard = function(entranceLink, observeClick) {
    this.initialize(entranceLink, observeClick);
};

ModalWizard.prototype = {
    url: null,
    modal: null,
    className: null,

    /*
        Public Getters / Setters
    */
    getModal: function(){
        return this.modal;
    },
    setModal: function(modal){
        this.modal = modal;
    },
    getClassName: function(){
        return this.className;
    },
    setClassName: function(className){
        this.className = className;
    },
    getUrl: function() {
        return this.url;
    },
    setUrl: function(url) {
        this.url = url;
    },
    setMethod: function(method) {
        return this.getModal().setMethod(method);
    },
    /*
        Public Methods
    */
    initialize: function(entranceLink, observeClick){
        var entranceLinkElement = document.getElementById(entranceLink);
        if(entranceLinkElement){
            if(observeClick){
                jQuery(entranceLinkElement).on('click', jQuery.proxy(this._handleLinkClick, this), true);
            }
            this.url = entranceLinkElement.href;
        } else {
            this.url = entranceLink;
        }
        ModalManager._currentModalWizard = this;
        this.modal = ModalManager.getCurrentModal();
    },

    start: function(url, className, formData){
        this.getModal().setFormData(formData);
        this.getModal().activate(url || this.getUrl(), className || this.getClassName());
    },

    finish: function(){
        this.getModal().deactivate();
    },

    /*
        Private Methods
    */
    _handleLinkClick: function(e){
        hideCurrentMenu();
        e.stopPropagation();
        this.start();
    }
};

module.exports = ModalWizard;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var MITS = __webpack_require__(3);

MITS.AjaxAPI = __webpack_require__(23);
MITS.DrillAcrossHelper = __webpack_require__(24);
MITS.Events = __webpack_require__(14);
MITS.Storage = __webpack_require__(26);
MITS.UI = __webpack_require__(28);
MITS.WebRemoting = __webpack_require__(6);
MITS.Widgets = __webpack_require__(41);

//This are delegates because user code expects them to be on MITS, but we're trying to eliminate dependencies on the
// root MITS object in the children
MITS.getCurrentModal = function() {
    return MITS.Widgets.ModalManager.getCurrentModal();
};

MITS.getCurrentMessageModal = function() {
    return MITS.Widgets.ModalManager.getCurrentMessageModal();
};

MITS.getCurrentModalWizard = function(){
    return MITS.Widgets.ModalManager.getCurrentModalWizard();
};
MITS.getPreferenceManager = function() {
    return MITS.Storage.getPreferenceManager();
};

module.exports = MITS;// This is expected to end up in a global var named 'MITS'

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var AjaxAPI = {};

AjaxAPI.Base = __webpack_require__(4);
AjaxAPI.Form = __webpack_require__(8);
AjaxAPI.ImmediateRequest = __webpack_require__(9);
AjaxAPI.Request = __webpack_require__(10);

module.exports = AjaxAPI;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DrillAcrossHelper = {};

var EXPLORE_DASHBOARD_DRILL_ACROSS_ITEMS_ID = 'exploreDashboardDrillAcrossItems'; // hidden div listing the drillacross options at each indention level

/*
 * returns content to be placed in the Explore Menu (drill across to dashboards)
 */
DrillAcrossHelper.createDashboardDrillAcrossMenu = function(indentLevel, link){

    var listItemHtml = '';

    // when we're in a dashboard, each grid (ie each table) will have its own list of drillacross items, so
    // see if we can find the explore data in the sibling nodes
    var exploreDataDiv =  null;
    var row = link.parentNode.parentNode.parentNode;  // it's a link inside a div inside a td inside a tr
    var dashboardTableDiv = row.parentNode.parentNode.parentNode; // row inside a tbody inside a table inside a div
    for(var i = 0; i < dashboardTableDiv.children.length; i++){
        if( dashboardTableDiv.children[i].id === EXPLORE_DASHBOARD_DRILL_ACROSS_ITEMS_ID ){
            exploreDataDiv = dashboardTableDiv.children[i];
        }
    }

    // if the data's not next to us then here's hoping we're on a report and there's just one of it per page
    if(!exploreDataDiv){
        exploreDataDiv  = document.getElementById(EXPLORE_DASHBOARD_DRILL_ACROSS_ITEMS_ID);
    }

    if(exploreDataDiv){
        // parse the list (in order of indention level) of lists of drill across configs
        var indentLevelDataSet = null;
        try{
            indentLevelDataSet = JSON.parse(exploreDataDiv.innerHTML);
        } catch (parseExeption){
            console.error('Unable to parse drill across json. Exception: ' +parseExeption + ' Json: ' + exploreDataDiv.innerHTML);
        }

        if(indentLevelDataSet && indentLevelDataSet.length > indentLevel-1){
            // Get the individual items
            var drillacrossList = indentLevelDataSet[indentLevel-1];

            // find the value at this row for each prompt
            var drillDownDimensions =   row.getAttribute('ids').split(';;;');
            var drillDownValues =  row.getAttribute('idvals').split(';;;');

            listItemHtml = DrillAcrossHelper.generateDrillAcrossHtml(drillacrossList, drillDownDimensions, drillDownValues, indentLevel);
        }
    }

    return listItemHtml;
};

/*
 * Generate the <li> elements for drilling across to dashboards for the currently clicked row or data point
 *
 * drillacrossList - the list of lists of drill across definitions at this indention level that should be added to the menu
 * drillDownDimensions - dimensions on the drill down path to this point
 * drillDownValues - the single values in parallel to drillDownDimensions down to this point
 * indentLevel - the indent level we're at (just for the id of the link)
 */
DrillAcrossHelper.generateDrillAcrossHtml = function(drillacrossList, drillDownDimensions, drillDownValues, indentLevel){
    var listItemHtml = '';
    if(drillacrossList && drillacrossList.length > 0){
        for(var i = 0; i < drillacrossList.length; i++){

            var drillacrossDefinition = drillacrossList[i];

            var url = 'displayFullScreenDashboard.flow?libraryName=' + encodeURIComponent(drillacrossDefinition.dashboardLibrary);
            url += '&id=' + encodeURIComponent(drillacrossDefinition.dashboardId) + '&valuesAreDescriptions=false';

            var promptNames = drillacrossDefinition.promptNames;
            // Note: These are just used to match with identifiers on the current report, they are not necessarily
            // the identifier abbreviations of the prompts, if those prompts are on a different cube.
            var promptNameMappings = drillacrossDefinition.promptNameMappings;
            for(var j = 0; j < promptNames.length; j++){
                var value = '';
                var valueIndex = drillDownDimensions.indexOf(promptNameMappings[j]);
                if(valueIndex >= 0){
                    value = drillDownValues[valueIndex];
                }

                url += '&' + encodeURIComponent(promptNames[j]) + '=' + encodeURIComponent(value);
            }

            var dashID = drillacrossDefinition.dashboardId;

            // in the sidebar, just close the menu.  But from a report or fullscreen dash,
            // disable the page so they can't click until the dashboard launches
            var inSidebar = window.frames.self.name === 'mits_dashboard';
            var onclick = inSidebar?'hideCurrentMenu()':'disablePage()';

            var item = '';
            item += '<li onmouseover="flashDrillAcrossOptionsMouseOver(this);" onmouseout="flashDrillAcrossOptionsMouseOut(this);"';
            item += 'onclick=' +  onclick + '>';
            item += '<a target="mits_main" id="drillacross-'+ indentLevel + '" onclick="disableUnsavedWarning()"';
            if(i === 0) item += ' class="after_edge" ';  			// this goes along with the 'addedge' class used in the explore list
            item += 'dashboardId="' + drillacrossDefinition.dashboardId + '" ';  // include dashboard ID for selenium testing purposes

            // add the span with the prettified dashboard id
            // use double quotes to surround URL because encodeURIComponent() does not escape single quotes
            var escapedDescription = jQuery('<div>').text(drillacrossDefinition.dashboardDescription).html();
            item +=  'href="' + url + '">';
            item += '<span class="menuItem">' + escapedDescription + '</span></a></li>';

            listItemHtml += item;
        }
    }
    return listItemHtml;
};

module.exports = DrillAcrossHelper;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var IPreferencesManager = __webpack_require__(15);

var CookiePreferencesManager = function() {
    this.initialize();
};

jQuery.extend(jQuery.extend(CookiePreferencesManager.prototype, IPreferencesManager), {
    /*
        Public Methods
    */
    initialize: function(){}, // no initialization really necessary

    /*
        Implementation: IPreferencesManager
    */
    setPreference: function(name, value){
        var expDate = new Date();
        expDate.setTime(expDate.getTime() + 1000 * 60 * 60 * 24 * 365);        // set expiration for a year from now
        document.cookie = name + '=' + escape(value) + '; expires=' + expDate.toGMTString() + '; path=/; ';
    },

    getPreference: function(name){
        var nameEQ = name + '=';
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0) ===' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    },

    deletePreference: function(name){
        var expDate = new Date();
        expDate.setTime(-1);
        document.cookie = name + '=; expires=' + expDate.toGMTString() + '; path=/; ';
    }
});

module.exports = CookiePreferencesManager;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Storage = {};

Storage.CookiePreferencesManager = __webpack_require__(25);
Storage.IPreferencesManager = __webpack_require__(15);

Storage._preferenceManager = new Storage.CookiePreferencesManager();
Storage.getPreferenceManager = function() {
    return Storage._preferenceManager;
};

module.exports = Storage;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ItemHighlighter = function () {
    this.initialize();
};

ItemHighlighter.prototype = {

    _itemsToHighlight: {},  // map from keys to the IDs of elements that should be highlighted for each
    _currentlyHighlighted: null,

    highlightCss: 'hover',

    initialize: function () {
    },

    addItemToHighlight: function (key, itemId) {
        if (!document.getElementById(itemId)) {
            return;
        }

        var items = this._itemsToHighlight[key];
        if (items == null) {
            items = new Array();
            this._itemsToHighlight[key] = items;
        }
        var index = items.indexOf(itemId);
        if (index < 0) {
            this._itemsToHighlight[key].push(itemId);
            if (this._currentlyHighlighted === key) {
                MITS.jQueryById(itemId).addClass(this.highlightCss);
            }
        }
    },

    removeItemToHighlight: function (key, itemId) {
        var $item =  MITS.jQueryById(itemId);
        if ($item.length === 0) {
            return;
        }

        var items = this._itemsToHighlight[key];
        if (items != null) {
            var index = items.indexOf(itemId);
            if (index >= 0) {
                items.splice(index, 1);
                this._itemsToHighlight[key] = items;
            }

            if (this._currentlyHighlighted === key) {
                $item.removeClass(this.highlightCss);
            }
        }
    },


    toggleHighlighting: function (key) {
        if (this._currentlyHighlighted !== key) {
            this.unHighlightItems(this._currentlyHighlighted);
            this.highlightItems(key);
        } else {
            this._currentlyHighlighted = null;
            this.unHighlightItems(key);
        }
    },

    highlightItems: function (key) {
        this._currentlyHighlighted = key;

        MITS.jQueryById(key + '_mouseover').addClass("active");

        var items = this._itemsToHighlight[key];
        if (items != null) {
            var numItems = items.length;
            for (var i = 0; i < numItems; i++) {
                var $item = MITS.jQueryById(items[i]);
                if ($item.length) { // guard against element ids that aren't actually there
                    if (!$item.hasClass(this.highlightCss)) {
                        $item.addClass(this.highlightCss);
                    }
                }
            }
        }
    },

    unHighlightItems: function (key) {
        if (key == null) return;

        MITS.jQueryById(key + '_mouseover').removeClass("active");

        var items = this._itemsToHighlight[key];
        if (items != null) {
            var numItems = items.length;
            for (var i = 0; i < numItems; i++) {
                var $item = MITS.jQueryById(items[i]);
                if ($item.length) {
                    if ($item.hasClass(this.highlightCss)) {
                        $item.removeClass(this.highlightCss);
                    }
                }
            }
        }
    }
};

module.exports = ItemHighlighter;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var UI = {};

UI.ItemHighlighter = __webpack_require__(27);
UI.Util = __webpack_require__(5);

module.exports = UI;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var AjaxFormInPlaceTransition = function(ajaxForm, formParent) {
    this.initialize(ajaxForm, formParent);
};

AjaxFormInPlaceTransition.prototype = {
    ajaxForm: null,
    formParent: null,
    transitionable: null,

    initialize: function(ajaxForm, formParent){
        this.ajaxForm = ajaxForm;
        this.formParent = document.getElementById(formParent);

        var inplacedom = document.createElement('div');
        inplacedom.style.display = 'none';
        document.body.appendChild(inplacedom);

        this.ajaxForm.setContentContainer(inplacedom);
        this.ajaxForm.addCompleteEvent(function(){
            var containingNode = this.formParent.parentNode;
            var newParentNode = this.ajaxForm.getContentContainer();

            var transitionableElement = this.transitionable.getElement();
            if(transitionableElement != null){
                newParentNode.appendChild(transitionableElement);
            }
            inplacedom.style.display = '';
            this.transitionable.setExitParticipant(newParentNode);
            containingNode.replaceChild(newParentNode, this.formParent);
            this.transitionable.exitTransition.bind(this.transitionable)();

            this.formParent = null;
        }.bind(this));
    },

    /**
     * @param element The ID of the element.
     * @param transitionable
     * NOTE: There is the potential that this method will go away at some future point, as the intention is that this was meant to maintain
     * visual consistency with MITS Report.  However, the question of whether or not we should still be doing so is up in the air.
     */
    registerTransitionable: function (element, transitionable) {
        //TODO: Rehook this to the click events
        this.ajaxForm.addSubmitEvent(function () {
            this.transitionable = transitionable;
            transitionable.enterTransition.bind(transitionable)();
        }.bind(this));
    },

    toString: function () {
        return '[MITS.Widgets.AjaxFormInPlaceTransition]';
    }
};

module.exports = AjaxFormInPlaceTransition;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var WebRemoting = __webpack_require__(6);
var Util = __webpack_require__(13);
WebRemoting.require('ChartingService');

var Chart = function(chartDivId, isDashboardChart, isSidebar, mwml, chartData) {
    this.initialize(chartDivId, isDashboardChart, isSidebar, mwml, chartData);
};

Chart._uniquenessCounter = 0;

/* "static" div id uniquifier since charts that have the same dchart tag end up with the same div id */
Chart.uniqueifyDivId = function(div){
    div.id = div.id + '_' + Chart._uniquenessCounter++;
};


Chart.prototype = {

    chartDivId: null,
    mwml: '',

    blankChartMessageFontSize: '14px',
    blankChartMessageFontHeight: 19,

    noDataMessage: 'No data available',
    noDataMessageWidth:109,  // with the default highcharts settings, how wide is this message at blankChartMessageFontSize.

    fetchChartErrorMessage: 'Error getting data',
    fetchChartErrorMessageWidth:111,

    renderChartErrorMessage: 'Error showing chart',
    renderChartErrorMessageWidth:123,

    isDashboardChart: true,
    isSidebar: false,

    /*
     Public Methods
     */

    initialize: function(chartDivId, isDashboardChart, isSidebar, mwml, chartData){

        this.chartDivId = chartDivId;

        if(!(document.getElementById(this.chartDivId))) {
            console.error('Render-to div ' + this.chartDivId + ' not found');
            return false;
        }

        if( isDashboardChart ){
            this.isDashboardChart = isDashboardChart;
            this.isSidebar = isSidebar;
            this.mwml = mwml;

            if(isSidebar){
                Util.addElementVisibleEvent('dashboardResizeTab', function(){
                    if(chartData){
                        this.renderChart(chartData);
                    } else {
                        this.fetchDashboardChart();
                    }
                }.bind(this));
            } else {
                if(chartData){
                    this.renderChart(chartData);
                } else {
                    this.fetchDashboardChart();
                }
            }
        } else {
            this.isDashboardChart = false;
        }
    },

    fetchDashboardChart: function(){
        if(!this.isDashboardChart){
            return false;
        }
        var options = {
            callback: this.renderDashboardChartFromJson.bind(this),

            errorHandler: function(message, exception) {
                this.receiveChartFailureCallback('ERROR '+message , exception);
            }.bind(this),

            warningHandler: function(message, exception) {
                this.receiveChartFailureCallback('WARNING '+ message, exception);
            }.bind(this),

            exceptionHandler: function(message, exception) {
                this.receiveChartFailureCallback('EXCEPTION '+message, exception);
            }.bind(this)
        };

        // If we're in a sidebar, then we may not have enough room to display the chart at the requested dimensions.
        // Set the actual div height to be proportional to the actual width,
        // and report the width to the java side so it can do the same calculation for label rotation, etc.
        // Note these attributes are also examined by dashboardFrameWidthController when resizing the sidebar
        var actualWidth;
        var actualHeight;
        if(this.isSidebar){
            var $chartDiv = this._get$ChartDiv();
            actualWidth = $chartDiv.width();
            var requestedWidth = $chartDiv.attr('chartWidth');
            var requestedHeight = $chartDiv.attr('chartHeight');
            actualHeight = Math.floor(requestedHeight * (actualWidth/requestedWidth));
            $chartDiv.css({height: actualHeight + 'px'});
        }

        ChartingService.getDashboardChartJsonFromMwml(this.mwml, actualWidth, options);

    },

    _get$ChartDiv: function() {
        var escapedId =  this.chartDivId.replace( /(:|\.|\[|\]|,)/g, '\\$1' );
        return jQuery('#' + escapedId);
    },

    renderDashboardChartFromJson: function(chartDataJson) {
        this.renderChart(JSON.parse(chartDataJson));
    },

    /*
     * used by charts in dashboards and also the wizard
     */
    /* eslint-disable complexity */
    renderChart: function(chartData) {
        try{
            chartData.chart.renderTo = this.chartDivId;

            // test if there's no data returned, and just show an empty chart if so
            var hasData = false;
            var serieses = chartData.series;
            validateData:
                    for(var i = 0; i < serieses.length; i++){
                        var series = serieses[i];
                        if(series.data !== undefined && series.data.length > 0 ){
                            for(var j = 0; j < series.data.length; j++ ){
                                if( series.data[j] != null){
                                    if( typeof series.data[j] === 'number') {
                                        hasData = true;
                                        break validateData;
                                    } else if ( typeof series.data[j] === 'object' ){
                                        if( typeof series.data[j].y !== 'undefined' ){
                                            hasData = true;
                                        } else {
                                            // if data points don't have a y value at all set them to null
                                            series.data[j].y = null;
                                        }
                                    }
                                }
                            }
                        }
                    }

            if (! hasData ){
                var width = chartData.chart.width;
                var height = chartData.chart.height;
                chartData = this._getBlankChartConfiguration();
                var chartCallback = this._getBlankChartCallback(width, height, this.noDataMessage, this.noDataMessageWidth);

                new Highcharts.Chart(chartData, chartCallback);
                return;
            }

            // set the dimensions to zero so highcharts just fills the containing div, and
            // continues to use the size of the containing div while it is resized
            chartData.chart.width = null;
            chartData.chart.height = null; //note: if the height of the div is less than 20 then highcharts will default to 400.  Search for comment "the offsetHeight of an empty container is 0 in standard browsers, but 19 in IE7:"

            // turn the formatter function (if any) into a function.  Keep this in sync with renderSVG.js
            if( chartData.xAxis && chartData.xAxis.labels && chartData.xAxis.labels.formatter){
                chartData.xAxis.labels.formatter = new Function(chartData.xAxis.labels.formatter);
            }
            if( chartData.plotOptions.pie && chartData.plotOptions.pie.dataLabels.formatter){
                chartData.plotOptions.pie.dataLabels.formatter = new Function(chartData.plotOptions.pie.dataLabels.formatter);
            }
            if( chartData.plotOptions.series && chartData.plotOptions.series.dataLabels.formatter){
                chartData.plotOptions.series.dataLabels.formatter = new Function(chartData.plotOptions.series.dataLabels.formatter);
            }

            // hide drill down menu when clicking elsewhere on the chart
            if(!chartData.chart.events){ chartData.chart.events = {}; }
            chartData.chart.events.click = function() {
                hideCurrentMenu();
            };

            // doit
            var chart = new Highcharts.Chart(chartData);

        } catch (error){
            try{
                // attempt to show a chart saying we had trouble rendering the real chart.  Ignore errors.
                var width = this._get$ChartDiv().width();
                var height = this._get$ChartDiv().height();
                chartData = this._getBlankChartConfiguration();
                chartCallback = this._getBlankChartCallback(width, height, this.renderChartErrorMessage, this.renderChartErrorMessageWidth);
                console.error(error);

                new Highcharts.Chart(chartData, chartCallback);
            }catch(error2){
            }
        }

        return chart;
    },
    /* eslint-enable complexity */

    receiveChartFailureCallback: function(message, exception) {

        try{
            var $chartDiv = this._get$ChartDiv();
            var $parentDiv = $chartDiv.parent().parent();
            var commentNode;
            if ( this.isDashboardChart && exception.javaClassName === 'com.mits.discover.services.flashscreen.exceptions.SecurityIssueStructuredErrorException') {
                // entirely hidden by security
                commentNode = document.createComment('Chart removed: ' + message);
                $parentDiv.empty();
                $parentDiv.append(commentNode);
            } else {
                console.error('Error fetching chart data.  Message: ' + message + ' Exception: ' + dwr.util.toDescriptiveString(exception, 2));
                // attempt to show a chart saying we had trouble getting the real chart data.
                var width = $chartDiv.width();
                var height = $chartDiv.height();
                var chartData = this._getBlankChartConfiguration();
                var chartCallback = this._getBlankChartCallback(width, height, this.fetchChartErrorMessage, this.fetchChartErrorMessageWidth);
                // un-hide header and footer since we have data
                var $siblings = $chartDiv.parent().children();
                $siblings.removeClass('invisible');
                new Highcharts.Chart(chartData, chartCallback);
                commentNode = document.createComment(message);
                $parentDiv.append(commentNode);
            }
        }catch(error2){
            console.error('error trying to handle an error ' + error2);
        }
    },

    _getBlankChartConfiguration : function(){
        return {
            chart: {
                renderTo: this.chartDivId,
                type:'column'
            },
            title:{ text:'' },
            credits:{ enabled: false },
            tooltip:{ enabled: false },
            xAxis: {
                lineWidth: 1,
                categories: [],
                labels:{ enabled: false }
            },
            yAxis:{
                gridLineColor: null,
                lineWidth: 1,
                labels:{ enabled: false },
                title:{ text:'' }
            },
            legend:{ enabled: false },
            series: [{data:[0]}]
        };
    },

    _getBlankChartCallback:function(width, height, message, messageWidth){

        var x = width/2 - messageWidth/2;
        var y = height/2;
        var font = this.blankChartMessageFontSize;

        // this will be called on complete, to add text to the chart via its renderer
        return function(chart) {
            chart.renderer.text(message,x, y)
                    .css({
                        color: '#4572A7',
                        fontSize: font
                    })
                    .add();
        };
    }
};

module.exports = Chart;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ElementSpecificMessage = __webpack_require__(19);
var CheckableItemsList = __webpack_require__(17);
var BootstrapAccordion = __webpack_require__(16);

var WebRemoting = __webpack_require__(6);
WebRemoting.require('ColumnSelectorService');
WebRemoting.require('MrColumnSelectorService');

var ColumnSelector = function(container, options) {
    this.initialize(container, options);
};

ColumnSelector.prototype = {
    /**
     * Contains messages displayed to the user which need to be set
     * by the JSP at request-time with internationalized values.
     */
    _messages: {
        loading: null
    },

    _maxSearchResults: 500,

    /**
     * Configuration Options for widget
     */
    _container: null,
    _sourceId: null, // the source to get columns for, either a MD cube or a MR report source.
    _isMrSource: false, // indicates if the 'sourceId' is a MITS Report source
    _multiselect: false,
    _drillDownPathDimensionAbbreviations: null,
    _currentColumnIds: null,
    _includeCalculatedColumns: false,
    _includeExternalColumns: true,
    _selectedOrderableItemListWidget: null,
    _clickListener: null,
    _$searchInput: null,
    _searchButton: null,
    _initiallySelectedColumns: [],

    /**
     * Other internal fields
     */
    _resultsLoadingMessage: null,
    _formBackingData: null, //just for reference/debugging
    _rootWidgetNodeDiv: null,
    _rootWidgetNode: null, //contains all the widgets
    _currentlyDisplayedList: null,
    _columns: null, //used to search against, generated from _formBackingData
    _$searchCheckableItemsListDiv: null,
    _searchCheckableItemsList: null,

    /* eslint-disable complexity */
    initialize: function(container, options){
        this._container = typeof container === 'string' ? document.getElementById(container) : container;
        var messageCssClass = 'busyMessage';
        var initialSelections = null;

        if (options) {
            if (options.selectedOrderableItemListWidget) {
                this._selectedOrderableItemListWidget = options.selectedOrderableItemListWidget;
            }

            if (options.messages) {
                this._messages = options.messages;
            }

            if (options.clickListener) {
                this._clickListener = options.clickListener;
            }

            if (options.multiselect) {
                this._multiselect = options.multiselect;
            }else{
                this._multiselect = false; //default
            }

            if (options.drillDownPathDimensionAbbreviations) {
                this._drillDownPathDimensionAbbreviations = options.drillDownPathDimensionAbbreviations;
            }

            if (options.currentColumnIds) {
                this._currentColumnIds = options.currentColumnIds;
            }

            //Note: this assumes a default of false because we will not go into the if-statement if trying to set it to false
            if (options.includeCalculatedColumns) {
                this._includeCalculatedColumns = options.includeCalculatedColumns;
            }

            if (options.includeExternalColumns !== undefined) {
                this._includeExternalColumns = options.includeExternalColumns;
            }

            if (options.initialSelections) {
                initialSelections = options.initialSelections;
                this._initiallySelectedColumns = options.initialSelections;
            }

            if (options.messageCssClass) {
                messageCssClass = options.messageCssClass;
            }

            if (options.sourceId) {
                this._sourceId = options.sourceId;
            }

            if(options.isMrSource){
                this._isMrSource = options.isMrSource;
            }

            if (options.searchInput) {
                if (typeof options.searchInput === 'string') {
                    this._$searchInput = jQuery('#' + options.searchInput);
                } else {
                    this._$searchInput = jQuery(options.searchInput);
                }
            }

            if (options.searchButton) {
                this._searchButton = options.searchButton;
            }
        }

        // Global variables have to be initialized after the messages are set.
        // The JSP sets the messages as the page is loading.
        this._resultsLoadingMessage = new ElementSpecificMessage(this._container, this._messages.loading, {messageCssClass: messageCssClass});

        //create a child div to hold the tree of accordions
        this._rootWidgetNodeDiv = document.createElement('div');
        this._container.appendChild(this._rootWidgetNodeDiv);

        //register uncheck listener
        //HACK: Note: this will overwrite any existing removeListener on the OrderableItemWidget
        if(this._selectedOrderableItemListWidget) {
            this._selectedOrderableItemListWidget._removeListener = this.uncheckColumn.bind(this);
        }

        this._populate();

        // This can be called any time after the page is loaded
        if(initialSelections && this._selectedOrderableItemListWidget){
            for (var i=0; i<initialSelections.length; i++) {
                this._selectedOrderableItemListWidget.addItem(initialSelections[i].id, initialSelections[i].description);
            }
        }

        this._initializeSearch();
    },
    /* eslint-enable complexity */

    _debounce: function(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        }; 
    },
    
    _initializeSearch: function(){
        //setup search functionality
        if(this._$searchInput){
            this._$searchCheckableItemsListDiv = jQuery('<div></div>');
            this._$searchCheckableItemsListDiv.hide();
            this._$searchCheckableItemsListDiv.appendTo(this._container);
            this._$searchInput.on('input', this._debounce(this._searchListener.bind(this), 250, true));

            if(this._searchButton){
                jQuery(this._searchButton).on('click', this._searchListener.bind(this));
            }
        }
    },

    _populate: function(){
        var msg = this._resultsLoadingMessage;
        // This is to get around an order of operations problem. For _resultsLoadingMessage to size and position itself
        // correctly, its parent must be visible on the screen. However, if this ColumnSelector is on a dialog, it'll be
        // hidden by the .loading class until after it's initialized and rendered. So throwing the show() onto a timeout
        // to move that call to after the selector's been rendered
        setTimeout(function () {
            msg.show();
        }, 10);

        var options = WebRemoting.createRemoteCallOptions(
                this._displayFormBackingData.bind(this),
                this._fetchFormBackingDataFailureCallback.bind(this));
        if(this._isMrSource){
            // get MITS Report columns.  This is separate in the hopes that it won't be too hard to merge to hoverboard
            MrColumnSelectorService.getFormBackingData(this._sourceId, options);
        } else {
            var selectedColumns = {};
            for (var i=0; i<this._initiallySelectedColumns.length; i++){
                selectedColumns[this._initiallySelectedColumns[i].id] = this._initiallySelectedColumns[i].description;
            }
            ColumnSelectorService.getFormBackingData(this._sourceId, this._drillDownPathDimensionAbbreviations, this._currentColumnIds, selectedColumns, this._includeCalculatedColumns, this._includeExternalColumns, options);
        }
    },

    _displayFormBackingData: function(columnSelectionData) {
        //Make sure the widget is still on the page.  Example: The user could have closed a modal.
        if(!this._container || !document.getElementById(this._container.id)){
            this._resultsLoadingMessage.hide();
            return;
        }

        var formBackingData = columnSelectionData.data;

        this._formBackingData = formBackingData;
        this._rootWidgetNode = new ColumnSelector.WidgetNode(this._rootWidgetNodeDiv, {formBackingData: formBackingData, parentColumnSelector: this}); //this builds the UI
        this._resultsLoadingMessage.hide();

        //Auto-expand to the first selected column
        if(this._selectedOrderableItemListWidget){
            var checkedColumnIds = this._selectedOrderableItemListWidget.getOrderedIds();

            if(checkedColumnIds && checkedColumnIds.length>0){
                var firstSelectedColumnId = checkedColumnIds[0];
                if(firstSelectedColumnId){
                    this.expandToColumn(firstSelectedColumnId);
                }
            }
        }

        this._columns = this._createColumnsList(this._formBackingData);

        //do a search if the user typed in the search box while we were fetching the list of columns
        if(this._$searchInput){
            this.search(this._$searchInput.val());
        }
    },

    _fetchFormBackingDataFailureCallback: function() {
        this._resultsLoadingMessage.hide();
    },

    _createColumnsList: function(formBackingData){
        var columnIdToColumnMap = []; //map of id to column

        //use a map to ensure we do not get duplicate columns in the list
        this._addColumnToMap(columnIdToColumnMap, formBackingData);

        var columnsList = [];

        for(var columnId in columnIdToColumnMap){
            var column = columnIdToColumnMap[columnId];
            columnsList.push(column);
        }

        //Note: Do not need to sort the list, because the search will sort them by relevance

        return columnsList;
    },

    _addColumnToMap: function(columnIdToColumnMap, formBackingData){
        if(this._isFormBackingDataCheckableItemsList(formBackingData)){
            for(var i=0;i<formBackingData.length;i++){
                var column = formBackingData[i];
                columnIdToColumnMap[column.id] = column;
            }
        }else{
            for(var key in formBackingData){
                var nestedFormBackingData = formBackingData[key];
                this._addColumnToMap(columnIdToColumnMap, nestedFormBackingData);
            }
        }
    },

    checkColumn: function(columnId) {
        if (this._currentlyDisplayedList) {
            this._currentlyDisplayedList.checkItem(columnId);
        }
        if (this._searchCheckableItemsList) {
            this._searchCheckableItemsList.checkItem(columnId);
        }
    },

    uncheckColumn: function(columnId) {
        if (this._currentlyDisplayedList) {
            this._currentlyDisplayedList.uncheckItem(columnId);
        }
        if (this._searchCheckableItemsList) {
            this._searchCheckableItemsList.uncheckItem(columnId);
        }
    },

    uncheckAllColumns: function() {
        if (this._currentlyDisplayedList) {
            this._currentlyDisplayedList.uncheckAllItems();
        }
        if (this._searchCheckableItemsList) {
            this._searchCheckableItemsList.uncheckAllItems();
        }
    },

    hideLoadingMessage: function(){
        this._resultsLoadingMessage.hide();
    },

    /**
     * Expands to the first instance of columnId in the tree
     */
    expandToColumn: function(columnId) {
        if(this._rootWidgetNode){
            this._rootWidgetNode.expandToColumn(columnId);
        }
    },

    _searchListener: function(){
        this.search(this._$searchInput.val());
        return false;
    },

    /* eslint-disable complexity */
    search: function(searchInputText){
        if(!this._columns){
            //we have not gotten the list of columns yet so do not search
            return;
        }

        //if they are searching replace the current tree of columns with the search results,
        // otherwise just display the normal tree of columns.
        if(searchInputText && searchInputText.length>0){
            if(this._rootWidgetNodeDiv){
                jQuery(this._rootWidgetNodeDiv).hide();
            }

            if(this._$searchCheckableItemsListDiv){
                this._$searchCheckableItemsListDiv.show();
            }

            this._container.scrollTop = 0;

            //search on each word individually, each word is ANDed
            var result = this._columns;
            var quotedWords = searchInputText.split('"');

            var inputWords = new Array();
            for (var quotedWordIndex = 0; quotedWordIndex < quotedWords.length; quotedWordIndex++) {
                if (quotedWordIndex % 2 === 0) {
                    //outside quotes
                    var spaceDelimitedWords = quotedWords[quotedWordIndex].split(/\s+/);
                    for (var spaceWordIndex = 0; spaceWordIndex < spaceDelimitedWords.length; spaceWordIndex++) {
                        inputWords.push(spaceDelimitedWords[spaceWordIndex]);
                    }
                } else {
                    //inside quotes
                    inputWords.push(quotedWords[quotedWordIndex]);
                }
            }
            
            for(var wordIndex=0;wordIndex<inputWords.length;wordIndex++){
                var word = inputWords[wordIndex];

                //only search on non-whitespace
                if(word && word.length>0){
                    word = word.toLowerCase();
                    var newResult = new Array();
                    for (var resultIndex = 0; resultIndex < result.length; resultIndex++) {
                        var element = result[resultIndex];
                        if (element && element.description && element.description.toLowerCase().indexOf(word) > -1) {
                            newResult.push(element);
                        }
                    }
                    result = newResult;
                }
            }

            if(result && result.length>0){
                this._searchCheckableItemsList = this._createCheckableItemsList(this._$searchCheckableItemsListDiv[0], result, this._maxSearchResults);

            }else{
                this._$searchCheckableItemsListDiv.empty();
            }

        }else{
            if(this._$searchCheckableItemsListDiv){
                this._$searchCheckableItemsListDiv.hide();
            }

            if(this._rootWidgetNodeDiv){
                jQuery(this._rootWidgetNodeDiv).show();
            }
        }
    },
    /* eslint-enable complexity */

    _createCheckableItemsList: function(containerDiv, columns, maxItems){
        var checkableItemsOptions = {
            allowRangeSelection: this._multiselect,
            useRadioButtons: !this._multiselect,
            clickListener: this._checkableItemsListClickListener.bind(this)
        };

        var widget = new CheckableItemsList(containerDiv, checkableItemsOptions);

        for(var i=0;i<columns.length && i < maxItems;i++){
            var columnInfo = columns[i];
            var id = columns[i].id;
            var isChecked = this._isItemSelected(id);
            widget.addItem(columnInfo.id, columnInfo.description, isChecked);
        }

        if (columns.length > maxItems) {
            widget.addAdditionalItemsNotice('Only the first ' + maxItems + ' results shown. Please use search options to find specific results');
        }

        return widget;
    },

    // Gets called when a checkbox is clicked. It updates the selected columns list.
    _checkableItemsListClickListener: function(columnId, description, isChecked) {
        if(!this._doClickListener(columnId, description, isChecked)){
            return false;
        }

        if(this._multiselect){
            if (isChecked) {
                this._addSelectedItem(columnId, description);
            }
            else {
                this._removeSelectedItem(columnId);
            }
        }else{
            this._removeAllItems();
            this._addSelectedItem(columnId, description);
        }
    },

    _doClickListener: function(columnId, description, isChecked){
        //If this is the root node then it should have a _clickListener to execute,
        if(this._clickListener){
            if(!this._clickListener(columnId, description, isChecked)){
                return false;
            }
        }

        return true;
    },

    /*
        Internal Methods for making sure the widget that holds the selections is notified about updates.
     */
    _addSelectedItem: function(columnId, description){
        if(this._selectedOrderableItemListWidget) {
            return this._selectedOrderableItemListWidget.addItem(columnId, description);
        }
    },

    _removeSelectedItem: function(columnId){
        if(this._selectedOrderableItemListWidget) {
            return this._selectedOrderableItemListWidget.removeItem(columnId);
        }
    },

    _removeAllItems: function(){
        if(this._selectedOrderableItemListWidget) {
            return this._selectedOrderableItemListWidget.removeAllItems();
        }
    },

    _isItemSelected: function(columnId){
        if(this._selectedOrderableItemListWidget) {
            return this._selectedOrderableItemListWidget.containsItem(columnId);
        }
    },


    /*
        Helper Methods
     */
    _isFormBackingDataCheckableItemsList: function(formBackingData){
        return (formBackingData.constructor === Array);
    }
};

ColumnSelector.WidgetNode = function(container, options) {
    this.initialize(container, options);
};

ColumnSelector.WidgetNode.prototype = {
    /**
     * Provides a
     * by the JSP at request-time with internationalized values.
     */
    _container: null,

    _parentColumnSelector: null, //for fetching configuration information that pertains to the whole tree of nodes

    _formBackingData: null, //form backing data for this node and descendants

    _accordion: null,

    _childWidgetNodes: null,
    _childAccordionNames: null,

    initialize: function(container, options){
        this._container = typeof container === 'string' ? document.getElementById(container) : container;

        if (options) {
            //_parentColumnSelector must be set before anything else, because the rest of the code requires
            // _parentColumnSelector to be set so it can access configuration information.
            if(options.parentColumnSelector) {
                this._parentColumnSelector = options.parentColumnSelector;
            }

            //When we receive "formBackingData" as an option we construct the WidgetNode tree.
            if (options.formBackingData) {
                var nodeLevel = 0;

                if(options.nodeLevel){
                    nodeLevel = options.nodeLevel;
                }

                this._formBackingData = options.formBackingData;
                this._initializeNodeFromFormBackingData(this._container, this._formBackingData, nodeLevel);
            }
        }
    },

    /**
     * Expands to the first instance of columnId in the tree.
     *
     * @return boolean true if the column was found to expand
     */
    expandToColumn: function(columnId, isRecursiveCall) {
        if (this._isFormBackingDataCheckableItemsList(this._formBackingData)) {
            for (var i = 0; i < this._formBackingData.length; i++) {
                var formBackingColumn = this._formBackingData[i];

                if (formBackingColumn.id === columnId) {
                    return true;
                }
            }
        } else {
            for (var j=0;j<this._childAccordionNames.length;j++) {
                //which accordion does this go with???
                var groupName = this._childAccordionNames[j];
                var nestedWidgetNode = this._childWidgetNodes[j];

                var nestedFormBackingData = this._formBackingData[groupName];
                if (nestedFormBackingData) {
                    if (nestedWidgetNode.expandToColumn(columnId, true)) {
                        this._expandAccordionWidget(groupName, isRecursiveCall);
                        if(this._accordion) {
                            this._accordion.expand(groupName);
                        }
                        return true;
                    }
                }
            }
        }

        return false;
    },

    _initializeNodeFromFormBackingData: function(containerDiv, formBackingData, nodeLevel){
        if(this._isFormBackingDataCheckableItemsList(formBackingData)){
            //the list of selectable columns, do not create it here.  It gets created when that widget is expanded.

        }else{
            //Nested Group
            this._initializeAccordionWidget(containerDiv, formBackingData, nodeLevel);
        }
    },

    _initializeAccordionWidget: function(containerDiv, formBackingData, nodeLevel){
        //only indent if this is not the first div
        containerDiv.style.marginLeft = (nodeLevel === 0 ? '0px' : '24px');

        var headings = [];
        var headingContents = [];

        var accordionOptions = {showExpandCollapseIcon: true,
            expandListener: this._expandAccordionWidget.bind(this),
            collapseCompleteListener: this._collapseAccordionWidget.bind(this),
            scrollContainer: this._parentColumnSelector._container
        };

        this._accordion = new BootstrapAccordion(containerDiv, accordionOptions);
        this._childWidgetNodes = [];
        this._childAccordionNames = [];

        for(var key in formBackingData) {
            headings.push(key.htmlDecode()); // encode keys for html here

            var nestedFormBackingData = formBackingData[key];

            var widgetNodeOptions = {
                parentColumnSelector: this._parentColumnSelector,
                formBackingData: nestedFormBackingData,
                nodeLevel: nodeLevel+1
            };


            var nestedDiv = document.createElement('div');
            this._container.appendChild(nestedDiv);

            var childWidgetNode = new ColumnSelector.WidgetNode(nestedDiv, widgetNodeOptions);

            headingContents.push(nestedDiv);
            this._childWidgetNodes.push(childWidgetNode);
            this._childAccordionNames.push(key);
        }

        this._accordion.setHeadings(headings, headingContents);
    },

    _expandAccordionWidget: function(groupName){
        if(this._accordion){
            var nestedFormBackingData = this._formBackingData[groupName];

            if(nestedFormBackingData){
                if(this._isFormBackingDataCheckableItemsList(nestedFormBackingData)){
                    var nestedDiv = document.createElement('div');
                    this._container.appendChild(nestedDiv);

                    var nestedCheckableItemsList = this._parentColumnSelector._createCheckableItemsList(nestedDiv, nestedFormBackingData, Number.MAX_VALUE);
                    this._parentColumnSelector._currentlyDisplayedList = nestedCheckableItemsList;

                    this._accordion.setHeadingContent(groupName, nestedDiv);
                }
            }
        }
    },

    /**
     * When the user collapses a group, we remove the column table from
     * the DOM to prevent the DOM from growing to large and slowing down
     * the java script.
     *
     * Also closes all children.
     */
    _collapseAccordionWidget: function(groupName, e) {
        if (this._accordion) {
            if (groupName) {
                var nestedFormBackingData = this._formBackingData[groupName];

                if (nestedFormBackingData) {
                    if (this._isFormBackingDataCheckableItemsList(nestedFormBackingData)) {
                        this._accordion.setHeadingContent(groupName, document.createTextNode(''));
                    }
                }
            } else {
                this._collapseAll();
            }
        }

        //The click event to collapse the node will bubble up the parent nodes, but we don't want those to close. So only
        //collapsing all children if this is the node clicked
        if (e.currentTarget === e.target) {
            this._collapseAllChildren();
        }
    },

    _collapseAllChildren: function() {
        //make sure children are collapsed too
        if (this._childWidgetNodes) {
            for(var i=0;i<this._childWidgetNodes.length;i++){
                var childWidgetNode = this._childWidgetNodes[i];
                childWidgetNode._collapseAll();
            }
        }
    },

    _collapseAll: function() {
        if (this._accordion) {
            this._accordion.collapseAll();
        }
        this._collapseAllChildren();
    },

    _isFormBackingDataCheckableItemsList: function(formBackingData){
        return this._parentColumnSelector._isFormBackingDataCheckableItemsList(formBackingData);
    }
};

module.exports = ColumnSelector;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Handles the hide/show logic of a collapsable details view
 */


var DetailsToggleWidget = function(elementID, elementToShowHideID) {
    this.initialize(elementID, elementToShowHideID);
};

DetailsToggleWidget.prototype = {
    $link: null,
    $label: null,
    $details: null,

    /**
     * Creates a new instance of the DetailsToggleWidget class
     * <b>Example:</b><br/>
     * To have a link which displayed an error log, you could have the following:<br/><br/>
     * <i>The Link</i>: <a href='#' class='detailsLink' detailsLink='errorLog'>Click here to <span viewLabel='view'
     * hideLabel="hide">view</span> the error log</a><br/><br/>
     * You'll note the following characteristics:
     * <ul>
     *    <li><i>class='detailsLink'</i>: REQUIRED - This indicates that this is a DetailedToggleWidget</li>
     *    <li><i>detailsLink='errorLog'</i>: REQUIRED - This indicates that this DetailedToggleWidget is tied to the element with the id of "errorLog"</li>
     *    <li><i><span viewLabel='view' hideLabel='hide'></i>: OPTIONAL - This optionally swaps the view label and hide label based upon the state of the toggle
     * </ul>
     *
     * And that's all there is to it.
     * @constructor
     * @member DetailsToggleWidget
     * @param {String/Object} elementID The id of the element to use as the clickable to show/hide
     * @param {String/Object} elementToShowHideID The id of the element object to show/hide
     */
    initialize: function (elementID, elementToShowHideID) {
        // Get the element from either an object or an id
        this.$link = jQuery('#' + elementID);
        if (this.$link.length === 0) {
            return;
        }

        this.$details = jQuery('#' + elementToShowHideID);
        if (this.$details.length === 0) {
            return;
        }

        if (this.$details.hasClass('hiddenDetails')) {
            this.$details.hide();
            this.$details.removeClass('hiddenDetails');
        }

        var $labelTemp = jQuery('#' + elementID + ' span');
        if ($labelTemp.length){
            this.$label = jQuery($labelTemp[0]);
        }

        this.$link.on('click', jQuery.proxy(this.toggle, this));
    },

    toggle: function(){
        if(!this.$details.is(':visible')){
            this.$details.show();
            if (this.$label){
                if (this.$label.attr('hideLabel')){
                    this.$label.html(this.$label.attr('hideLabel'));
                }
            }
            this.$link.removeClass('detailsLink');
            this.$link.addClass('detailsCollapsable');
        } else {
            this.$details.hide();
            if(this.$label) {
                if (this.$label.attr('viewLabel')) {
                    this.$label.html(this.$label.attr('viewLabel'));
                }
            }
            this.$link.addClass('detailsLink');
            this.$link.removeClass('detailsCollapsable');
        }
        return false;
    }
};

module.exports = DetailsToggleWidget;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This object takes a table and makes it possible to highlight a row by
 * clicking on it.
 *
 * If the table has a tbody element, all rows in the tbody will be affected.
 * If there isn't a tbody, all rows in the table will be affected.
 * "numRowsToSkip" can be specified in the options, indicating to skip the
 * first N rows in the tbody if it exists, else the table.
 *
 * When the HighlightableRowTable is created, it walks the table and prepares
 * the rows, adding css and event listeners.  If rows are dynamically added to
 * the table later, each new row should be passed to the prepareRow() function.
 */


var HighlightableRowsTable = function (tableId, options) {
    this.initialize(tableId, options);
};

HighlightableRowsTable.prototype = {

    _clickedCss: 'hover',
    _highlightListener: function () {
    },
    _lastRowClickedOn: null,
    _highlightEnabled: true,
    _clickEnabled: true,

    /**
     * @param tableId - the ID of the table element
     * @param options - contains the following optional settings:
     *    highlightListener: a function that will be called when
     *            a row is highlighted or unhighlighted.  It will be passed
     *            two arguments, the row element, and a boolean that is true
     *            when highlighted.
     *        clickedCss: the CSS added to a table row iff the box is checked
     */
    initialize: function (tableId, options) {

        var table = document.getElementById(tableId);
        var numRowsToSkip = 0;

        //allow the user to override the defaults, if desired
        if (options) {
            if (options.clickedCss) {
                this._clickedCss = options.clickedCss;
            }

            if (options.highlightListener) {
                this._highlightListener = options.highlightListener;
            }

            if (options.numRowsToSkip) {
                numRowsToSkip = options.numRowsToSkip;
            }
        }

        if (table != null) {
            //skip the header rows, if any, by getting rows from the tbody
            var rowContainer = table.getElementsByTagName('tbody')[0];

            if (rowContainer == null) {
                rowContainer = table;
            }

            var rows = rowContainer.children;

            for (var i = numRowsToSkip; i < rows.length; i++) {
                this.prepareRow(rows[i]);
            }
        }
    },

    /**
     * Note: don't call this function more than once for the same
     * row. It would add multiple listeners to the row, which would
     * step on each other.
     */
    prepareRow: function (row) {
        row.style.cursor = 'default';
        jQuery(row).on('mousedown', function (e) {
            return this._handleRowClick(row, e);
        }.bind(this));
    },


    /**
     * Public mutators to allow enabling/disabling certain behaviors of this
     * object.
     */
    disableHighlighting: function () {
        this._highlightEnabled = false;
        this._removeLastHightlight();
    },

    enableHighlighting: function () {
        this._highlightEnabled = true;

        //re-display the last highlighted row
        if (this._lastRowClickedOn != null) {
            var row = this._lastRowClickedOn;
            this._highlightRow(row);
        }
    },

    disableClickHandler: function () {
        this._clickEnabled = false;
    },

    enableClickHandler: function () {
        this._clickEnabled = true;
    },


    /**
     * Event handler function.
     */
    _handleRowClick: function (row, e) {
        if (!this._clickEnabled) {
            return false;
        }

        this._removeLastHightlight();

        if (row === this._lastRowClickedOn) {
            this._lastRowClickedOn = null;
        }
        else {
            this._highlightRow(row);
        }
    },

    _highlightRow: function (row) {
        this._highlightListener(row, true);
        jQuery(row).addClass(this._clickedCss);
        this._lastRowClickedOn = row;
    },

    _removeLastHightlight: function () {
        if (this._lastRowClickedOn != null) {
            //call the listener
            this._highlightListener(this._lastRowClickedOn, false);
            jQuery(this._lastRowClickedOn).removeClass(this._clickedCss);
        }
    }
};

module.exports = HighlightableRowsTable;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BaseModal = __webpack_require__(7);
var ModalManager = __webpack_require__(2);

var WidgetUtils = __webpack_require__(0);
WidgetUtils.requireStylesheet('MITS.Widgets.MessageModal');

var MessageModal = function(text, spanClassName, className) {
    this.initialize(text, spanClassName, className);
};

jQuery.extend(jQuery.extend(MessageModal.prototype, BaseModal.prototype), {
    modalText: null,
    modalId: 'messageModal',
    spanClassName: null,

    MODAL_CONTENT_CLASS: 'modalMessageContent',
    MODAL_CLASS: 'modalMessage',

    /*
        Public Methods
    */
    initialize: function(text, spanClassName, className) {
        ModalManager._currentMessageModal = this;
        this.modalText = text;
        this.className = className || 'genericMessageModal';
        this.spanClassName = spanClassName || 'genericMessage';
        this._loadMarkupOnLoad();
    },

    toString: function(){
        return '[MessageModal]';
    },

    /*
        Private Methods
    */
    _createAdditionalContent: function($modalBody) {
        $modalBody.append('<div><span class="' + this.spanClassName + '">' + this.modalText + '</span></div>');
    }
});

module.exports = MessageModal;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ModalManager = __webpack_require__(2);
var Form = __webpack_require__(8);

var ModalWizardPage = function (form) {
    this.initialize(form);
};
ModalWizardPage.prototype = {
    wizard: null,
    ajaxForm: null,

    /*
        Public Methods
    */

    /**
     * @param formID The ID of the form element.
     */
    initialize: function(formID) {
        this.ajaxForm = new Form(formID);
        this.wizard = ModalManager.getCurrentModalWizard();

        this.ajaxForm.setContentContainer(this.wizard.getModal().getContentContainer());
        this.ajaxForm.setEvaluateJavascript(true);
        this.ajaxForm.addSubmitEvent(this.wizard.getModal().showLoading.bind(this.wizard.getModal()));
        this.ajaxForm.addCompleteEvent(this.wizard.getModal().hideLoading.bind(this.wizard.getModal()));
        this.ajaxForm.addCompleteEvent(this._cleanup.bind(this));
        this.ajaxForm.addValidationFailureEvent(this.wizard.getModal().hideLoading.bind(this.wizard.getModal()));
    },

    _cleanup: function() {
        delete(this.wizard);
        delete(this.ajaxForm);
    }

};

module.exports = ModalWizardPage;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Modal = {};

Modal.BaseModal = __webpack_require__(7);
Modal.ModalWizard = __webpack_require__(21);
Modal.ModalWizardPage = __webpack_require__(35);

module.exports = Modal;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var MITS = __webpack_require__(3);
var Util = __webpack_require__(5);
var WidgetUtils = __webpack_require__(0);
WidgetUtils.requireStylesheet('MITS.Widgets.OrderableItemList');

/**
 * Displays a collection of items can be ordered and removed. Ordering
 * is done with drag/drop and remove is done by double clicking.
 * The widget must start as an empty container
 * and have items dynamically added.  This widget can be used inside
 * of a form to post the ordered items.  Alternatively, it can return
 * the ordered item IDs to include in an AJAX request.
 */
var OrderableItemList = function (container, options) {
    this.initialize(container, options);
};

OrderableItemList._instanceCount = 1;
OrderableItemList.prototype = {

    //--- Constants ---
    _divIdPrefix: 'orderableItemId_',
    _topAnchorDivIdPrefix: 'topAnchorId_',

    //--- Internal State Variables ----
    // Counts the total items that have been added. NOT the same as current
    // item count because it doesn't decrement when removing.
    _sequenceCounter: 0,
    _currentItemCount: 0,
    // Maps from item IDs to the unique sequence number
    _itemToSequenceNumberMap: null,
    // Maps from the unique sequence numbers to the item ID
    _sequenceNumberToItemMap: null,
    _sequenceNumberToDescriptionMap: null, // and to its description
    _container: null,

    //--- Configurable Defaults ----
    _moveListener: function () {
    },
    _removeListener: function () {
    },
    _removeIconCssClass: 'fa fa-times fa-2x',
    _lockedIconUrl: 'fa fa-lock',
    _oddItemCss: 'oddDraggable',
    _evenItemCss: 'evenDraggable',
    _oddUndraggableItemCss: 'oddUndraggable',
    _evenUndraggableItemCss: 'evenUndraggable',
    _descriptionCss: 'undraggableDescription',
    _draggingCss: 'movingDraggable',
    _contentCss: 'draggableContent',
    _scrollContainer: null,
    _formFieldName: null,
    _makeHtmlLiteral: false,
    //Currently always true because I can't get the padding right in both cases.
    _itemsAreRemovable: true,
    _doubleclickRemoves: true,


    /**
     * @param container - The ID of a (presumably) empty DOM element for which the draggable elements will be placed.
     * @param options - contains the following optional settings:
     *        removeListener: A function called when the widget has
     *            removed an item due to the remove icon being clicked.
     *            It is passed the item ID.
     *      removeIconCssClass: A relative url to the image to use as the remove-button.
     *      removeIconHoverUrl: A different image to display as the remove-button when hovering over it
     *        oddItemCss: A CSS class name added to every other item in the list
     *        evenItemCss: A CSS class name added to every other item in the list
     *        draggingCss: A CSS class name added to an item while it is being dragged
     *        isContainerScrollable: Indicates if the container has a scroll bar that
     *            should be auto-scrolled when the user drags an item to the top or
     *            bottom.  If not set to true, the default is to scroll the window if needed.
     *        formFieldName: When using this widget inside of a form, a hidden form
     *            field will be created for each item.  The caller provides the
     *            name of the form field by setting the formFieldName, and the
     *            value of the form fields will be the IDs of the items.
     */
    /* eslint-disable complexity */
    initialize: function (container, options) {

        if (typeof container !== 'string'){
            console.error('For the ValuesList widget, expecting the input parameter \'container\' to be of type string, but was type \'' + (typeof container) + '\'.');
        }
        //Give this instance a unique prefix it can use for it's items so they don't clash
        //with IDs for items from other OrderableItemList instances on the same page.
        this._divIdPrefix = this._divIdPrefix + OrderableItemList._instanceCount + '_';
        this._topAnchorDivIdPrefix = this._topAnchorDivIdPrefix + OrderableItemList._instanceCount + '_';
        OrderableItemList._instanceCount++;

        //Note: These can't be initialized prior to this in the prototype because
        //we want each instance to have its own map instead of globally shared maps.
        this._itemToSequenceNumberMap = {};
        this._sequenceNumberToItemMap = {};
        this._sequenceNumberToDescriptionMap = {};

        jQuery('#' + container).empty();
        this._container = document.getElementById(container);

        if (options) {
            if (options.moveListener) {
                this._moveListener = options.moveListener;
            }

            if (options.removeListener) {
                this._removeListener = options.removeListener;
            }

            if (options.doubleclickRemoves != null) {
                this._doubleclickRemoves = options.doubleclickRemoves;
            }

            if (options.oddItemCss) {
                this._oddItemCss = options.oddItemCss;
            }

            if (options.evenItemCss) {
                this._evenItemCss = options.evenItemCss;
            }

            if (options.draggingCss) {
                this._draggingCss = options.draggingCss;
            }

            if (options.formFieldName) {
                this._formFieldName = options.formFieldName;
            }

            if (options.removeIconCssClass) {
                this._removeIconCssClass = options.removeIconCssClass;
            }

            if (options.makeHtmlLiteral) {
                this._makeHtmlLiteral = options.makeHtmlLiteral;
            }

            if (options.isContainerScrollable) {
                this._scrollContainer = this._container;
            }
            else {
                this._scrollContainer = window;
            }
        }

        var lastPlaceholderIndex = -1;

        var _this = this;
        jQuery(this._container).sortable({
            containerSelector: '#' + this._scrollContainer.id,
            // This is necessary to distinguish between lists opened on the same page. This includes the same one opened,
            // closed, and reopened because jQuery-sortable reuses objects if you let is, confusing everything.
            group: 'OrderableItemListContainer' + OrderableItemList._instanceCount,
            axis: 'y',
            itemSelector: '.oddDraggable,.evenDraggable',
            placeholder: '<div id="placeholder" class="placeholder"/>',
            //The scroll-specific parameters are used by the OrderableItemList to handle scrolling, as scrolling isn't explicitly supported
            //in the underlying jquery-sortable component.
            scroll: true,
            scrollSensitivity: 20,
            scrollSpeed: 8,
            adjustment: {},

            // Makes item you are moving stay under the cursor at the place that you clicked it to start dragging
            //rather than having the item you are moving off to the side of the cursor
            onDragStart: function ($item, container, _super) {
                if (this.scroll) {
                    if (container.superSearchValidTarget === undefined) {
                        // Squirreling away the super impl so it can be called by the overriding method below
                        // See: https://github.com/johnny/jquery-sortable/blob/0.9.13/source/js/jquery-sortable.js line 313
                        container.superSearchValidTarget = container.searchValidTarget;
                    }

                    var initialScrollPosition = {
                        lastPointerScrollTop: null,
                        scrollTop: _this._scrollContainer.scrollTop
                    };

                    // The Container.searchValidTarget method is responsible for finding where the placeholder is placed.
                    // Unfortunately it isn't aware of the scroll container's scroll position. Overriding it here so as t
                    // to pass in pointer positions that reflect the scroll position
                    container.searchValidTarget = function (pointer) {
                        var adjustedPointer = Object.assign({}, pointer, {top: pointer.top - (initialScrollPosition.scrollTop - _this._scrollContainer.scrollTop)});
                        var adjustedLastPointer = initialScrollPosition.lastPointer;
                        initialScrollPosition.lastPointer = adjustedPointer;

                        return container.superSearchValidTarget(adjustedPointer, adjustedLastPointer);
                    };
                }
                //Alter the placeholder associated with the container so that it uses a copy of the element being dragged.
                container.group.placeholder = jQuery($item).clone().prop('id', 'placeholder').addClass('placeholder');

                //Alter the dragged element so that it shows the 'selected' style under all circumstances.  This is done to make sure
                //that the dragged element keeps it's selected state even if the user mouses outside of the scroll container, but continues
                //to drag.
                $item.addClass('movingDraggable textSelectionDisabled');

                lastPlaceholderIndex = -1;
                var offset = $item.offset(), pointer = container.rootGroup.pointer;

                this.adjustment = {
                    left: pointer.left - offset.left,
                    top: pointer.top - offset.top
                };

                _super($item, container);
            },

            //Makes item you are moving stay under the cursor at the place that you clicked it to start dragging.
            //By only modifying the vertical positioning of the dragged element, we are able to prevent unnecessary horizontal
            //movement of the dragged element that doesn't serve a functional purpose.
            onDrag: function ($item, position) {
                //Reposition the ghost placeholder image that tracks mouse movement.
                $item.css({
                    top: jQuery(_this._scrollContainer).scrollTop() + position.top - this.adjustment.top
                });

                //Do scrolling
                if (this.scroll) {
                    //The jQuery-sortable implementation that we're using doesn't support scrolling.  As such, it's necessary to add
                    //in support for it here.  For the time being, this only supports vertical scrolling.
                    if (position.top < this.scrollSensitivity) {
                        _this._scrollContainer.scrollTop = _this._scrollContainer.scrollTop - this.scrollSpeed;
                    } else if (position.top >= _this._scrollContainer.offsetHeight - this.scrollSensitivity){
                        _this._scrollContainer.scrollTop = _this._scrollContainer.scrollTop + this.scrollSpeed;
                    }
                }
            },

            onDrop: function ($item, container, _super) {
                //Alter the dragged element so that it will no longer have the 'selected' style.
                $item.removeClass('movingDraggable');

                _super($item, container);
                _this._resetOddEvenCss();
            },

            //As the afterMove callback tracks every time the mouse moves, rather than only when the placeholder's position moves,
            //We track the index of the placeholder to detect when it has changed, and only then elements that we need to redraw.
            afterMove: function (placeholder, container, item) {
                var placeholderIndex = jQuery('#placeholder').index();
                if (placeholderIndex !== lastPlaceholderIndex) {
                    if (lastPlaceholderIndex !== -1) {
                        //Iterate over the subset of elements that have swapped positions due to the most recent move of the placeholder
                        //so that each element's even/odd striping can be properly set to reflect the change.
                        //NOTE: The nth-child call is one-indexed, while the placeholder index is zero-indexed.
                        if (placeholderIndex < lastPlaceholderIndex) {
                            //If the placeholder is being moved upward, toggle the even/odd CSS of all elements
                            //from after the new location of the placeholder, up to and including the previous location of the placeholder.
                            for (var i = placeholderIndex + 1; i <= lastPlaceholderIndex; i++) {
                                _this._toggleOddEvenCss(jQuery(container.options.containerSelector + ' > :nth-child(' + (i + 1) + ')'));
                            }
                        } else {
                            //If the placeholder is being moved downward, toggle the even/odd CSS of all elements
                            //from the previous location of the placeholder to just before the new location of the placeholder.
                            for (var i = lastPlaceholderIndex; i <= placeholderIndex - 1; i++) {
                                _this._toggleOddEvenCss(jQuery(container.options.containerSelector + ' > :nth-child(' + (i + 1) + ')'));
                            }
                        }
                    }
                    lastPlaceholderIndex = placeholderIndex;
                }
            }
        });
        //HACK monkey patching the ContainerGroup.getPointer with one that works correctly on Android. The broken one
        //returns {left: undefined, right: undefined } confusing user code
        //See: https://github.com/johnny/jquery-sortable/blob/0.9.13/source/js/jquery-sortable.js line 403
        var _s = jQuery.data(this._container).sortable;
        _s.group.getPointer = function(e) {
            var o;
            if (!(e.originalEvent) || !(e.originalEvent.touches) || !(e.originalEvent.touches[0])) {
                o = {};
            } else {
                o = e.originalEvent.touches[0];
            }
            return {
                left: e.pageX || o.pageX,
                top: e.pageY || o.pageY
            };
        };
    },
    /* eslint-enable complexity */

    addItem: function (id, description) {
        if (this.containsItem(id)) {
            return;
        }

        this._itemToSequenceNumberMap[id] = this._sequenceCounter;
        this._sequenceNumberToItemMap[this._sequenceCounter] = id;
        this._sequenceNumberToDescriptionMap[this._sequenceCounter] = description;

        var div = document.createElement('div');
        div.id = this._divIdPrefix + this._sequenceCounter;

        if (this._currentItemCount % 2 === 0) {
            div.className = this._oddItemCss;
        } else {
            div.className = this._evenItemCss;
        }

        var draggableContent = this._generateDraggableContent(id, description);
        div.appendChild(draggableContent);

        if (this._formFieldName) {
            var formField = document.createElement('input');
            formField.type = 'hidden';
            formField.name = this._formFieldName;
            formField.value = id;
            div.appendChild(formField);
        }
        if (this._itemsAreRemovable && this._doubleclickRemoves) {
            this._addDoubleClickRemoveListener(div, id);
        }
        this._container.appendChild(div);
        this._sequenceCounter++;
        this._currentItemCount++;
    },

    addItemToUndraggableTopAnchoredSet: function (name, description) {
        var id = this._topAnchorDivIdPrefix + name;
        if (!document.getElementById(id)) {
            var div = document.createElement('div');

            div.id = id;

            var content = this._generateTopAnchorUndraggableContent(name, description);

            div.appendChild(content);

            // add right before top-most draggable item
            if (!this._container.hasChildNodes()) {
                this._container.appendChild(div);
            } else {
                var child = this._container.firstChild;
                while (child && child.tagName === 'DIV' && this._isATopAnchorId(child.id)) {
                    child = child.nextSibling;
                }

                if (child) {
                    this._container.insertBefore(div, child);
                } else {
                    this._container.appendChild(div);
                }
            }
        }

        this._resetOddEvenCss();
    },

    /**
     * Gets an array of the item IDs, in the order the items
     * appear.
     */
    getOrderedIds: function () {
        var itemIdArray = new Array();

        var divList = jQuery('#' + this._container.id).children();
        for (var i = 0; i < divList.length; i++) {
            var div = divList[i];
            var sequenceNumber = div.id.substring(this._divIdPrefix.length);
            var itemId = this._sequenceNumberToItemMap[sequenceNumber];
            itemIdArray.push(itemId);
        }

        return itemIdArray;
    },

    getOrderedDescriptions: function () {
        var itemDescriptionArray = new Array();

        var divList = jQuery('#' + this._container.id).children();
        for (var i = 0; i < divList.length; i++) {
            var div = divList[i];
            var sequenceNumber = div.id.substring(this._divIdPrefix.length);
            var itemDescription = this._sequenceNumberToDescriptionMap[sequenceNumber];
            itemDescriptionArray.push(itemDescription);
        }

        return itemDescriptionArray;
    },

    updateItemDescription: function (id, newDescription) {
        var sequenceNumber = this._itemToSequenceNumberMap[id];
        if (typeof sequenceNumber != 'number') {
            //item isn't in our list
            return;
        }
        var div = document.getElementById(this._divIdPrefix + sequenceNumber);
        var dragHandleDiv = div.firstChild;
        dragHandleDiv.removeChild(dragHandleDiv.firstChild);
        dragHandleDiv.appendChild(this._generateDraggableContent(id, newDescription));
    },

    removeItem: function (id) {
        var sequenceNumber = this._itemToSequenceNumberMap[id];
        if (typeof sequenceNumber != 'number') {
            //item isn't in our list
            return;
        }
        var div = document.getElementById(this._divIdPrefix + sequenceNumber);

        //Set the odd/even css for the items below the one
        //we're removing
        var currentItem = div.nextSibling;
        while (currentItem) {
            this._toggleOddEvenCss(currentItem);
            currentItem = currentItem.nextSibling;
        }

        this._container.removeChild(div);
        this._itemToSequenceNumberMap[id] = null;
        this._currentItemCount--;
    },

    removeAllItemsFromUndraggableTopAnchoredSet: function () {
        var divList = jQuery('#' + this._container.id).children();
        for (var i = 0; i < divList.length; i++) {
            var div = divList[i];
            if (this._isATopAnchorId(div.id)) {
                this._container.removeChild(div);
            }
        }
        this._resetOddEvenCss();
    },

    _isATopAnchorId: function (id) {
        var prefix = this._topAnchorDivIdPrefix;
        var preLen = prefix.length;
        return id && id.length >= preLen && id.substring(0, preLen) === prefix;
    },

    removeAllItems: function () {
        while (this._container.hasChildNodes()) {
            this._container.removeChild(this._container.firstChild);
        }

        this._itemToSequenceNumberMap = {};
        this._sequenceNumberToItemMap = {};
        this._sequenceNumberToDescriptionMap = {};
        this._currentItemCount = 0;
    },

    /** Indicates if an item with the specified ID is in the table. */
    containsItem: function (id) {
        return typeof this._itemToSequenceNumberMap[id] == 'number';
    },

    _generateDraggableContent: function (id, description) {
        if (this._itemsAreRemovable) {
            //create a table to get the image to center vertically when text wraps
            var table = document.createElement('table');
            var tbody = document.createElement('tbody');
            var row = document.createElement('tr');
            var dragHandleCell = document.createElement('td');
            var dragHandle = document.createElement('i');
            dragHandle.className = 'fa fa-ellipsis-v';
            dragHandleCell.appendChild(dragHandle);
            var cell = document.createElement('td');
            cell.className = 'removeIconCell';
            var image = document.createElement('i');
            image.className = this._removeIconCssClass;
            image.style.cursor = 'pointer';
            this._addSingleClickRemoveListener(image, id);

            var cell2 = document.createElement('td');
            cell2.style.width = '100%';
            cell2.appendChild(this._createItemTextDiv(description));

            table.appendChild(tbody);
            tbody.appendChild(row);
            row.appendChild(dragHandleCell);
            row.appendChild(cell);
            cell.appendChild(image);
            row.appendChild(cell2);

            return table;
        } else {
            return this._createItemTextDiv(description);
        }
    },


    _generateTopAnchorUndraggableContent: function (name, description) {
        var table = document.createElement('table');
        var tbody = document.createElement('tbody');
        var row = document.createElement('tr');
        var cell = document.createElement('td');
        cell.className = 'lockedIconCell';
        var image = document.createElement('i');
        image.className = this._lockedIconUrl;
        var cell2 = document.createElement('td');
        cell2.style.width = '100%';
        var content = this._createItemTextDiv(name);
        content.className = ''; // too much padding
        if (description && description.length > 0) {
            var descContent = this._createItemTextDiv(description);
            descContent.className = this._descriptionCss;
            content.appendChild(descContent);
        }
        cell2.appendChild(content);
        table.appendChild(tbody);
        tbody.appendChild(row);
        row.appendChild(cell);
        cell.appendChild(image);
        row.appendChild(cell2);
        return table;
    },

    _createItemTextDiv: function (text) {
        var textDiv = document.createElement('div');
        textDiv.className = 'draggableText';
        Util.disableTextSelection(textDiv);
        if (this._makeHtmlLiteral) {
            textDiv.appendChild(document.createTextNode(text));
        } else {
            textDiv.innerHTML = text;
        }

        return textDiv;
    },

    _addDoubleClickRemoveListener: function (element, itemId) {
        jQuery(element).dblclick(function () {
                this.removeItem(itemId);
                this._removeListener(itemId);
            }.bind(this)
        );
    },

    _addSingleClickRemoveListener: function (element, itemId) {
        var $element = jQuery(element);
        $element.bind('click touchend', function () {
            this.removeItem(itemId);
            this._removeListener(itemId);
        }.bind(this));
        $element.bind('mousedown touchstart', function (e) {
            e.stopPropagation();
        });
    },

    _toggleOddEvenCss: function (element) {
        if (jQuery(element).hasClass(this._oddItemCss)) {
            jQuery(element).removeClass(this._oddItemCss);
            jQuery(element).addClass(this._evenItemCss);
        } else {
            jQuery(element).addClass(this._oddItemCss);
            jQuery(element).removeClass(this._evenItemCss);
        }
    },

    _resetOddEvenCss: function () {
        var divList = jQuery('#' + this._container.id).children();
        for (var i = 0; i < divList.length; i++) {
            var isUndraggable = this._isATopAnchorId(divList[i].id);
            if (i % 2 === 0) {
                jQuery(divList[i]).removeClass(this._evenItemCss);
                jQuery(divList[i]).removeClass(this._evenUndraggableItemCss);
                jQuery(divList[i]).addClass(isUndraggable ? this._oddUndraggableItemCss : this._oddItemCss);
            } else {
                jQuery(divList[i]).removeClass(this._oddItemCss);
                jQuery(divList[i]).removeClass(this._oddUndraggableItemCss);
                jQuery(divList[i]).addClass(isUndraggable ? this._evenUndraggableItemCss : this._evenItemCss);
            }
        }
    }
};

module.exports = OrderableItemList;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var WidgetUtils = __webpack_require__(0);
WidgetUtils.requireStylesheet('MITS.Widgets.ProgressBar');

var ProgressBar = function (container, options) {
    this.initialize(container, options);
};

ProgressBar.prototype = {

    //Constants
    BACKGROUND_IMAGE_PIXEL_WIDTH: 350,
    _FRAME_IMAGE_URL: 'images/Widgets/ProgressBar/progressBarFrame.gif',

    _progressImageNode: null,

    /**
     * @param container a DOM element or element's ID
     *        where the widget will render itself.
     */
    initialize: function (container) {
        var progressImg = document.createElement('img');
        progressImg.src = this._FRAME_IMAGE_URL;
        progressImg.className = 'progressBar';
        jQuery(container).append(progressImg);
        this._progressImageNode = progressImg;
        this.setPercentage(0);
    },

    /**
     * @param percentage A number between 0 and 100.
     */
    setPercentage: function (percentage) {
        var shadedBackgroundWidth = this.BACKGROUND_IMAGE_PIXEL_WIDTH / 2;
        var shadedPixelsToDisplay = shadedBackgroundWidth * (percentage / 100);
        var shadedPixelsToHide = shadedBackgroundWidth - shadedPixelsToDisplay;
        this._progressImageNode.style.backgroundPosition = '-' + shadedPixelsToHide + 'px 0px';
    }
};

module.exports = ProgressBar;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Transitionable = __webpack_require__(12);

/*
    Typically used to display a little text message in a box in the corner
    of the screen, similar to Gmail's old-school red box that said "Loading...".

    @param notificationArea The ID of the element to be used as the notification area.
    @param message
    @param type
 */
var SimpleLoadingMessage = function(notificationArea, message, type) {
    this.initialize(notificationArea, message, type);
};

jQuery.extend(SimpleLoadingMessage.prototype, Transitionable, {
    DEFAULT_CLASS_NAME: 'generic',
    CLASS_SUFFIX: 'LoadingMessage', 

    parentNode: null,
    loadingDiv: null,
    message: null,
    className: null,
    delay: null,

    initialize: function(notificationArea, message, type){
        var notificationAreaElement = document.getElementById(notificationArea);

        this.parentNode = notificationAreaElement.getElementsByClassName('notificationArea')[0];
        if(!this.parentNode){
            this.parentNode = document.createElement('div');
            this.parentNode.className = 'notificationArea';
            notificationAreaElement.appendChild(this.parentNode);
        }

        this.message = message;
        this.className = (type ? type : this.DEFAULT_CLASS_NAME) + this.CLASS_SUFFIX;
    },

    /*
      Implementing: Transitionable
    */
    enterTransition: function(){
        if(this.delay){
            setTimeout(this._showMessage.bind(this), this.delay);
        } else {
            this._showMessage();
        }
    },

    exitTransition: function(){
        try {
            if(this.loadingDiv){
                var _this = this;
                var onComplete = function () {
                    _this.parentNode.removeChild(_this.loadingDiv);
                    _this.loadingDiv = null;
                };

                jQuery(this.loadingDiv).fadeOut(400, onComplete);
            }
        } catch (e) {
        }
    },

    getElement: function(){
        return this.loadingDiv;
    },

    setExitParticipant: function(obj){
        // Do nothing
    },

    setDelay: function(delay){
        this.delay = delay;
    },

    /**
      * @member SimpleLoadingMessage
      */
    toString: function(){
        return '[MITS.Widgets.SimpleLoadingMessage]: ' + this.element;
    },

    /*
        Protected Methods
    */
    _showMessage: function () {
        try {
            if (!this.loadingDiv) {
                this._generateElements();
                jQuery(this.loadingDiv).fadeIn(400);
                MITS.UI.Util.applyHighlightEffect(this.loadingDiv.id);
            }
        } catch (e) {
        }
    },

    _generateElements: function(){
        this.loadingDiv = document.createElement('div');
        this.loadingDiv.id = 'loadingDiv';
        this.loadingDiv.innerHTML = this.message;
        this.loadingDiv.className = this.className;
        this.loadingDiv.style.display = 'none';
        this.parentNode.appendChild(this.loadingDiv);
    }
});

module.exports = SimpleLoadingMessage;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var MITS = __webpack_require__(3);

var WidgetUtils = __webpack_require__(0);
WidgetUtils.requireStylesheet('MITS.Widgets.ValuesList');

var ValuesList = function (container, inputName, values, options) {
    this.initialize(container, inputName, values, options);
};

ValuesList._instanceCount = 1;
ValuesList.prototype = {
    _inputName: 'value', // the name attribute of the input elements created

    _divIdPrefix: 'valuesListDiv_',
    _container: null,

    // stuff from options
    _textBoxIsInput: false,  // should the text box also be an input bound to the same name
    _firstValueInTextBox: false,  // should the first value in the list be populated into the text box instead of the list div  
    _stack: false, // do new values go on the top or the bottom?

    _addValueMessage: 'Add a value: ',
    _noValuesMessage: 'No values set',
    _trimValue: false,  // should the value in the box be trimmed before adding it to the list

    _valueValidator: null,
    _hasValuesListener: null,
    _addValueListener: null,
    _removeValueListener: null,
    _inputListener: null,  // added to the onkeyup of the input box, takes the current value as a parameter

    _valueTableWidth: 270, // much smaller than this and the plus button will wrap around on ipad
    _valueTdWidth: 236,
    _noValuesTdWidth: 260,
    _tabindex: 1,   // of the add values text box on the page. For some reason starting at 0 makes it not work.

    /**
     * @param containerID - The ID of an empty DOM element.
     * @param inputName - the name attribute of the input elements that this will create
     * @param values -  the values to list
     */
    /* eslint-disable complexity */
    initialize: function (containerID, inputName, values, options) {

        if (typeof containerID !== 'string'){
            console.error('For the ValuesList widget, expecting the input parameter \'container\' to be of type string, but was type \'' + (typeof containerID) + '\'.');
        }

        //Give this instance a unique prefix it can use for its items so they don't clash
        //with IDs for items from other CheckableItemsList instances on the same page.
        this._divIdPrefix = this._divIdPrefix + ValuesList._instanceCount++ + '_';

        jQuery('#' + containerID).empty();
        this._container = document.getElementById(containerID);

        this._inputName = inputName;

        if (!options) {
            options = {};
        }
        if (options.textBoxIsInput) {
            this._textBoxIsInput = options.textBoxIsInput;
        }
        if (options.firstValueInTextBox) {
            this._firstValueInTextBox = options.firstValueInTextBox;
        }
        if (options.stack) {
            this._stack = options.stack;
        }

        if (options.addValueMessage) {
            this._addValueMessage = options.addValueMessage;
        }
        if (options.noValuesMessage) {
            this._noValuesMessage = options.noValuesMessage;
        }
        if (options.trimValue) {
            this._trimValue = options.trimValue;
        }

        if (options.valueValidator) {
            this._valueValidator = options.valueValidator;
        }
        if (options.hasValuesListener) {
            this._hasValuesListener = options.hasValuesListener;
        }
        if (options.addValueListener) {
            this._addValueListener = options.addValueListener;
        }
        if (options.removeValueListener) {
            this._removeValueListener = options.removeValueListener;
        }
        if (options.inputListener) {
            this._inputListener = options.inputListener;
        }

        if (options.valueTableWidth) {
            this._valueTableWidth = options.valueTableWidth;
        }
        if (options.valueTdWidth) {
            this._valueTdWidth = options.valueTdWidth;
        }
        if (options.noValuesTdWidth) {
            this._noValuesTdWidth = options.noValuesTdWidth;
        }

        if (options.tabindex) {
            this._tabindex = options.tabindex;
        }

        if (values == null) {
            values = [];
        }

        this._container.appendChild(this._generateAddValueDiv());

        if (this._firstValueInTextBox && values.length > 0) {
            document.getElementById(this._divIdPrefix + '_addValueInput').value = values[0];
            if (values.length > 1) {
                values = values.slice(1);
            } else {
                values = [];
            }
        }

        this._container.appendChild(this._generateValuesTable(values));

        this._setRowColoringOnValuesTable();

    },
    /* eslint-enable complexity */

    /* get a list of the values, in the order they've been specified
     * includes the text box if textBoxIsInput */
    getValues: function () {
        var valuesArray = new Array();
        var inputs = this._container.getElementsByTagName('input');
        for (var i = 0; i < inputs.length; i++) {
            var input = inputs[i];
            if (input.value !== '') {
                valuesArray.push(input.value);
            }
        }
        return valuesArray;
    },

    hasValueInTextBox: function () {
        return this._textBoxIsInput && document.getElementById(this._divIdPrefix + '_addValueInput').value !== '';
    },

    getTextBox: function () {
        return document.getElementById(this._divIdPrefix + '_addValueInput');
    },

    //text box and add button
    _generateAddValueDiv: function () {
        var addValueDiv = document.createElement('div');
        addValueDiv.className = 'nowrap';
        addValueDiv.style['width'] = this._valueTableWidth + 'px';
        addValueDiv.style['position'] = 'relative'; // crucial for making absolute position of valuesListAddButton work

        addValueDiv.appendChild(document.createTextNode(this._addValueMessage));

        //create a dummy empty input so that spring knows it's binding a list and the value in the other box is a single value even if it contains a comma
        var dummyInput = document.createElement('input');
        dummyInput.setAttribute('type', 'hidden');
        dummyInput.setAttribute('name', this._inputName);
        dummyInput.setAttribute('value', '');
        addValueDiv.appendChild(dummyInput);

        var textInput = document.createElement('input');
        textInput.setAttribute('tabindex', this._tabindex + 1);
        textInput.setAttribute('type', 'text');
        if (this._textBoxIsInput) {
            textInput.setAttribute('name', this._inputName);
        }

        textInput.setAttribute('id', this._divIdPrefix + '_addValueInput');
        textInput.setAttribute('value', '');
        textInput.onkeypress = function (event) {
            if (MITS.Util.wasThatTheEnterKey(event)) {
                this._addValue();
                return false;
            }
            return true;
        }.bind(this);

        textInput.onkeyup = function (textInput) {
            if (this._inputListener) {
                this._inputListener(textInput.value);
            }
        }.bind(this, textInput);

        addValueDiv.appendChild(textInput);

        var addButton = document.createElement('div');
        addButton.setAttribute('id', this._divIdPrefix + '_addValueLink');
        addButton.className = 'valuesListAddButton';
        addButton.onclick = function () {
            this._addValue();
            return false;
        }.bind(this);

        addValueDiv.appendChild(addButton);

        return addValueDiv;
    },


    _addValue: function () {
        var valueInput = document.getElementById(this._divIdPrefix + '_addValueInput');

        if (this._trimValue) {
            valueInput.value = valueInput.value.trim();
        }

        if (valueInput.value === ''){
            return false;
        }

        if (this._valueValidator && !this._valueValidator(valueInput.value)) {
            return false;
        }

        var tr = this._generateValueRow(valueInput.value);

        var table = document.getElementById(this._divIdPrefix + '_valuesTable');

        if (this._stack) {
            table.insertBefore(tr, table.firstChild);
        } else {
            table.appendChild(tr);
        }


        this._updateHasValuesStatus(table, true);
        this._setRowColoringOnValuesTable();

        valueInput.value = '';
        if (this._addValueListener) {
            this._addValueListener();
        }
    },


    _removeValue: function (removeButton) {
        var row = removeButton.parentNode.parentNode;
        row.parentNode.removeChild(row);
        this._setRowColoringOnValuesTable();

        var table = document.getElementById(this._divIdPrefix + '_valuesTable');
        if (table.getElementsByTagName('tr').length === 0) {
            this._updateHasValuesStatus(table, false);
        }
        if (this._removeValueListener) {
            this._removeValueListener();
        }
    },


    _updateHasValuesStatus: function (table, hasValues) {
        if (hasValues) {
            var noValuesRow = document.getElementById(this._divIdPrefix + '_noValuesRow');
            if (noValuesRow) {
                noValuesRow.parentNode.removeChild(noValuesRow);
            }
        } else {
            table.appendChild(this._generateNoValuesRow());
        }
        if (this._hasValuesListener) {
            this._hasValuesListener(hasValues);
        }
    },

    /*
     * the little table that shows values for a particular item
     */
    _generateValuesTable: function (values) {
        var div = document.createElement('div');
        div.style['marginTop'] = '15px';

        // add a table even if it's empty so it can have stuff added to it later
        var table = document.createElement('table');
        table.style['border'] = '1px solid #c0c0c0';
        table.style['tableLayout'] = 'fixed'; // make IE8 honor maxWidth
        table.style['width'] = this._valueTableWidth + 'px';
        table.style['maxWidth'] = this._valueTableWidth + 'px';

        table.id = this._divIdPrefix + '_valuesTable';
        table.setAttribute('cellspacing', '0');
        table.className = 'noBordersTable slimLineTable';

        if (values.length > 0) {
            for (var i = 0; i < values.length; i++) {
                table.appendChild(this._generateValueRow(values[i]));
            }
        } else {
            table.appendChild(this._generateNoValuesRow());
        }

        div.appendChild(table);
        return div;
    },

    /*
     * Generate one of the rows of the little table that shows values for a particular item
     */
    _generateValueRow: function (value) {
        var tr = document.createElement('tr');
        var textTd = document.createElement('td');
        textTd.style['width'] = this._valueTdWidth + 'px';
        textTd.style['maxWidth'] = this._valueTdWidth + 'px'; // can't deal with dashes when accessing styles via js so use maxWidth insted of max-width
        textTd.style['overflow'] = 'hidden';

        var hiddenInput = document.createElement('input');
        hiddenInput.setAttribute('type', 'hidden');
        hiddenInput.setAttribute('name', this._inputName);
        hiddenInput.setAttribute('value', value);
        textTd.appendChild(hiddenInput);
        textTd.appendChild(document.createTextNode(value.replace(/\s/g, '\u00a0'))); // &nbsp; would go in literally; the actual spaces get smushed.  unicode to the rescue!
        textTd.title = value;

        tr.appendChild(textTd);

        var removeButtonTd = document.createElement('td');
        removeButtonTd.align = 'right';
        removeButtonTd.style['padding'] = '4px';

        var removeButton = document.createElement('div');
        removeButton.className = 'valuesListDeleteButton';
        removeButton.onclick = function () {
            this._removeValue(removeButton);
            return false;
        }.bind(this);

        removeButtonTd.appendChild(removeButton);
        tr.appendChild(removeButtonTd);

        return tr;
    },

    _generateNoValuesRow: function () {
        var tr = document.createElement('tr');
        tr.setAttribute('id', this._divIdPrefix + '_noValuesRow');
        var td = document.createElement('td');
        td.setAttribute('colspan', '2');
        td.style['width'] = this._noValuesTdWidth + 'px';

        var span = document.createElement('span');
        span.className = 'note disabledText';
        span.appendChild(document.createTextNode(this._noValuesMessage));

        td.appendChild(span);
        tr.appendChild(td);
        return tr;
    },

    /*
     * Modify styles on DOM
     */

    _setRowColoringOnValuesTable: function () {
        var rows = document.getElementById(this._divIdPrefix + '_valuesTable').getElementsByTagName('tr');
        for (var i = 0; i < rows.length; i++) {
            if (rows[i].id !== this._divIdPrefix + '_noValuesRow') {
                var $row = jQuery(rows[i]);
                $row.removeClass((i % 2 === 0 ? 'evenRow' : 'oddRow'  ));
                $row.addClass((i % 2 === 0 ? 'oddRow' : 'evenRow' ));
            }
        }
    }
};

module.exports = ValuesList;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Widgets = {};

Widgets.AjaxFormInPlaceTransition = __webpack_require__(29);
Widgets.BootstrapAccordion = __webpack_require__(16);
Widgets.Chart = __webpack_require__(30);
Widgets.CheckableItemsList = __webpack_require__(17);
Widgets.CheckableRowsTable = __webpack_require__(18);
Widgets.ColumnSelector = __webpack_require__(31);
Widgets.DetailsToggleWidget = __webpack_require__(32);
Widgets.ElementSpecificMessage = __webpack_require__(19);
Widgets.FadeOutModal = __webpack_require__(20);
Widgets.HighlightableRowsTable = __webpack_require__(33);
Widgets.MessageModal = __webpack_require__(34);
Widgets.OrderableItemList = __webpack_require__(37);
Widgets.ProgressBar = __webpack_require__(38);
Widgets.SimpleLoadingMessage = __webpack_require__(39);
Widgets.ValuesList = __webpack_require__(40);
Widgets.WidgetUtils = __webpack_require__(0);
Widgets.Modal = __webpack_require__(36);
Widgets.ModalManager = __webpack_require__(2);

module.exports = Widgets;

/***/ }),
/* 42 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(22);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// mits.js